// frontend/src/App.js
import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { commaView, stripComma } from "./utils/number";
import axios from 'axios';
import { DEFAULT_FILTERS, FILTER_VISIBILITY_DEFAULTS } from "./constants/filters";
import { getProperties } from "./api/propertyApi";
import { getPropertyById } from "./api/propertyApi"; // ✅ 반드시 추가

import TourPlanner from "./components/TourPlanner";
import TourListsPage, { TourSaveModal } from "./components/TourListsPage";

// import AddressSearch from "./components/AddressSearch"; //★AddressSearch 관련
import KakaoMap from "./components/KakaoMap";
import MapPopup from "./pages/MapPopup";
import PropertyList from "./components/PropertyList";
import RegionSelector from "./components/RegionSelector";
import ErrorBoundary from "./components/ErrorBoundary";
import EstateEditor from "./components/EstateEditor";
import "./styles/OverlayPanel.css";
import "./components/Layout.css";
import ConditionManage from "./pages/ConditionManage";
import ConditionSearchPanel from "./components/ConditionSearchPanel";
import { BLD_TYPE_LABELS } from "./constants/bldLabels";
import Header from "./components/Header";
import GongsilView from "./components/GongsilView";   // [GONGSIL_MENU_V1] 공실클럽 수집자료
import AuthCallback from "./auth/AuthCallback";
// [SLIDER_CFG_CARD_V1] 필터 슬라이더 범위/단위 관리 카드 (관리탭에서 사용)
import SliderConfigManager from "./components/SliderConfigManager";
import RegionConfigManager from "./components/RegionConfigManager";
import SubmissionInbox from "./components/SubmissionInbox";  // [INBOX_CARD_V1]  // [REGION_CFG_CARD_V1]
import PermissionManager from "./components/PermissionManager";
import RealTradeConfig from "./components/RealTradeConfig";   // 실거래 조회 설정(중개사무소 반경)
// [SLIDER_PILOT_V1] 두 손잡이 범위 슬라이더 (필터 패널에서 사용)
import RangeSlider from "./components/RangeSlider";
import { buildStops } from "./utils/sliderStops";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MyProfile from "./pages/MyProfile";
import Home from "./pages/Home";
import KakaoLoginButton from "./components/KakaoLoginButton";
import LoginOverlay from "./auth/LoginOverlay";
import LoginGate from "./auth/LoginGate"; // [LOGIN_REDIRECT_V1] 로그인 관문
import EmailLogin from "./auth/EmailLogin";
import EmailRegister from "./auth/EmailRegister";
import useAuthGuard from "./hooks/useAuthGuard";
import HoListOverlay from "./components/HoListOverlay";
import { groupByAddress, getAddressKey } from "./utils/addressGroup";
import MobilePropertyDetail from './pages/MobilePropertyDetail';
import ReceiverManagePage from './pages/ReceiverManagePage';
import BackupButton from './components/BackupButton'; // 📦 프로젝트 백업 버튼
// [REMOVED_V1] import BuildingSearchPage from './pages/BuildingSearchPage';
import StaffIntake from "./pages/StaffIntake";
import BlogCreate from "./pages/BlogCreate";  // BLOGPAGE_ROUTE_V1
import PublicIntake from "./pages/PublicIntake";
import SubmissionPage from "./pages/SubmissionPage";
import SubmissionAlert from "./components/SubmissionAlert";  // [SUB_ALERT_V1]  // [SUB_PAGE_V1]  // [PUBLIC_INTAKE_ROUTE_V1]  // [STAFF_INTAKE_ROUTE_V1]
// [REMOVED_V1] import NaverAdmin from './components/NaverAdmin';
import RealTradePage from "./components/RealTradePage";

import ContractUpload from './pages/ContractUpload';
import ContractList from './pages/ContractList';
import ContractDetail from './pages/ContractDetail';
import ContractEdit from './pages/ContractEdit';
import ContractCalendar from './pages/ContractCalendar';
import ContractBatchUpload from './components/ContractBatchUpload';
import ContractManualEntry from './components/ContractManualEntry';
import ScheduleAlert from './components/ScheduleAlert';
import SmsRuleManager from './components/SmsRuleManager';
import SmsDirectSend from './components/SmsDirectSend';

// App.js — imports 아래에 추가
const ESTATE_TYPE_OPTIONS = [
  ["residence","주거용"],
  ["profit","수익성"],
  ["business","업무용"],
  ["commerce","상업용"],
];

const BLD_TYPE_OPTIONS = [
  ["apt","아파트"],
  ["business-bld","업무용빌딩"],
  ["shop-house","상가주택"],
  ["land","토지"],
  ["sale-shop","분양상가"],
  ["s-home-bld","단독주택"],
  ["multi-household","다가구주택"],
  ["single-room-bld","원룸건물"],
  ["single-room","원룸"],
  ["shop","상가"],
  ["multi-purpose","다용도"],
  ["office","사무실"],
  ["e-apt","오피스텔"],
  ["etc","기타"],
  ["metro-house","도시형주택"],
  ["multi-house","다세대주택"],
  ["row-house","연립주택"],
  ["single-room-owner","원룸주인세대"],
  ["villa","빌라"],
];

const RENT_TYPE_OPTIONS = [
  ["deal","매매"],   // [DEAL_FILTER_FIX_V1] sale(=분양) → deal(=매매). 서버 properties.js map 과 일치
  ["rent","월세"],
  ["charter","전세"],
  ["short","단기"],
];

const BLD_STRUCTURE_OPTIONS = [
  ["open","오픈형"],
  ["separate","분리형"],
  ["multi","복층형"],
];

const GRADE_CONDITION_OPTIONS = [
  ["manage","지속관리"],
  ["recommend","추천"],
  ["recommend-price","가성비"],
  ["attentive","계약유의"],
  ["nonrecommend","비추천"],
  ["prohibit","계약금지"],
];

const FACILITY_OPTIONS = [
  ["ev","승강기"], ["interior","인테리어"], ["water","수도시설"], ["city_gas","도시가스"],
  ["bath_div","화장실 남녀구분"], ["bath_in","화장실 내부"], ["exsign","옥외광고"],
  ["heat:center","중앙난방"], ["heat:floor","층별난방"], ["heat:private-heat","개별난방"],
  ["cold:center","중앙냉방"], ["cold:private","개별냉방"],
];

  // 평↔㎡
  const toNum = (v)=>{ const n = Number(String(v).replace(/[^0-9.]/g,"")); return Number.isFinite(n)? n : null; };
  const SQM_PER_PY = 3.305785;
  const sqm2py = (n)=> Number.isFinite(n)? +(n / SQM_PER_PY).toFixed(2) : "";
  const py2sqm = (n)=> Number.isFinite(n)? Math.round(n * SQM_PER_PY) : "";

  const VIS_KEY = "cm_visibility";
  const VAL_KEY = "cm_values";

// === 재사용 드롭다운들(App.js 상단에 추가) ===

// 단순 리듀서: 값/노출 각각 업데이트
function filtersReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER": {
      const { key, value } = action.payload;
      return { ...state, values: { ...state.values, [key]: value } };
    }
    case "SET_FILTERS": {
      return { ...state, values: { ...state.values, ...action.payload } };
    }
    case "SET_VIS": {
      const { key, value } = action.payload; // boolean
      return { ...state, visibility: { ...state.visibility, [key]: value } };
    }
    case "SET_VIS_ALL": {
      return { ...state, visibility: { ...state.visibility, ...action.payload } };
    }
    default:
      return state;
  }
}

function BlurCommitNumber({ initial, onCommit, ...rest }) {
  const ref = React.useRef(null);
  React.useEffect(()=>{ if(ref.current) ref.current.value = initial ?? ""; }, [initial]);
  return (
    <input
      {...rest}
      defaultValue={initial ?? ""}
      ref={ref}
      onBlur={e=>onCommit?.(e.target.value)}
      onKeyDown={e=>{ if(e.key==="Enter") e.currentTarget.blur(); }}
    />
  );
}

function MultiDropdown({label, options, values=[], onChange, width="100%"}) {
  const [open, setOpen] = useState(false);
  //const [pending, setPending] = useState(values);
  const panelRef = useRef(null);

  // 열릴 때 props→pending 동기화
  //useEffect(() => { if (open) setPending(values); }, [open, values]);

  // 체크 토글 시 즉시 onChange 호출
  const toggle = (v) => {
    const newValues = new Set(values); // 현재 부모의 상태(values)를 기준으로 Set 생성
    if (newValues.has(v)) {
      newValues.delete(v);
    } else {
      newValues.add(v);
    }
    onChange?.([...newValues]); // 변경된 값을 즉시 부모에게 전달
  };


  // 닫기만 수행 (값은 이미 즉시 반영됨)
  const commitAndClose = () => {
    setOpen(false);
  };

  return (

    <div style={{ position:"relative", display:"inline-block", width, maxWidth: 360 }}>
      <button type="button" onClick={()=>setOpen(o=>!o)}
        style={{width:"100%", padding:"6px 10px", textAlign:"left", border:"1px solid #ccc", borderRadius:6}}>
        {label} {values.length?`(${values.length})`:""}
      </button>
      {open && (
        <div
          ref={panelRef}
          tabIndex={-1}
          // 포커스가 빠져나가면 그냥 닫기
          onBlur={(e)=>{ if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false); }}
          style={{position:"absolute", zIndex:20, top:"100%", left:0, right:0,
                  background:"#fff", border:"1px solid #ddd", borderRadius:6, padding:8, marginTop:4,
                  boxShadow:"0 6px 20px rgba(0,0,0,.12)"}}
        >
          <label style={{display:"block", padding:"4px 2px"}}>
            <input
              type="checkbox"
              checked={values.length === 0} // pending 대신 values 사용
              onChange={(e)=>{
                if (e.target.checked) onChange?.([]); // 즉시 부모 상태 변경
              }}
            /> 전체
          </label>
          {options.map(([val,text])=>(
            <label key={val} style={{display:"block", padding:"4px 2px"}}>
              <input
                type="checkbox"
                checked={values.includes(val)} // pending 대신 values 사용
                onChange={()=>toggle(val)}
              /> {text}
            </label>
          ))}
          <div style={{display:"flex", justifyContent:"space-between", marginTop:6}}>
            {/* 초기화 버튼도 즉시 onChange 호출 */}
            <button type="button" onClick={()=> onChange?.([])} style={{padding:"4px 10px"}}>초기화</button>
            <button type="button" onClick={commitAndClose} style={{padding:"4px 10px"}}>닫기</button>
          </div>
        </div>
      )}
    </div>
  );
}

function SingleDropdown({label, options, value = "", onChange, width = "100%"}) {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  const close = () => setOpen(false);

  return (
    <div style={{ position:"relative", display:"inline-block", width, maxWidth: 360 }}>
      <button type="button" onClick={()=>setOpen(o=>!o)}
        style={{width:"100%", padding:"6px 10px", textAlign:"left", border:"1px solid #ccc", borderRadius:6}}>
        {label} {value?`(${options.find(o=>o[0]===value)?.[1]||""})`:""}
      </button>
      {open && (
        <div
          ref={panelRef}
          tabIndex={-1}
          onBlur={(e)=>{ if (!e.currentTarget.contains(e.relatedTarget)) close(); }} // commitAndClose 호출 부분을 close()로 변경
          style={{position:"absolute", zIndex:20, top:"100%", left:0, right:0,
                  background:"#fff", border:"1px solid #ddd", borderRadius:6, padding:8, marginTop:4,
                  boxShadow:"0 6px 20px rgba(0,0,0,.12)"}}
        >
          <label style={{display:"block", padding:"4px 2px"}}>
            <input
              type="radio"
              name={label}
              checked={!value}
              onChange={()=>onChange?.("")} // pending 상태 대신 즉시 onChange 호출
            /> 전체
          </label>
          {options.map(([val,text])=>(
            <label key={val} style={{display:"block", padding:"4px 2px"}}>
              <input
                type="radio"
                name={label}
                checked={value===val}
                onChange={()=>onChange?.(val)} // pending 상태 대신 즉시 onChange 호출
              /> {text}
            </label>
          ))}
          <div style={{display:"flex", justifyContent:"space-between", marginTop:6}}>
            <button type="button" onClick={()=>onChange?.("")} style={{padding:"4px 10px"}}>초기화</button>
            <button type="button" onClick={close} style={{padding:"4px 10px"}}>닫기</button>
          </div>
        </div>
      )}
    </div>
  );
}

// BlurCommitInput: 입력 중에는 값을 내부 state(val)에만 보관하고,
// Enter 키 또는 포커스 이탈(blur) 시에만 onCommit 호출 → 검색 실행
// ★ onChange prop도 받아서, 타이핑할 때마다 외부에서도 값을 추적할 수 있게 함
//    (통합검색 '키워드검색' 버튼이 클릭될 때 최신 입력값을 알기 위해 필요)
function BlurCommitInput({ value, onCommit, onChange: onChangeProp, ...rest }) {
  // [COMMA_V1] type="number" 인 숫자칸은 천단위 콤마로 표시하고,
  //   상태·커밋에는 콤마 없는 raw 숫자를 넘깁니다. (키워드 등 text 는 그대로)
  const isNum = rest.type === "number";
  const [val, setVal] = React.useState(value ?? "");
  React.useEffect(() => { setVal(value ?? ""); }, [value]);
  const commit = () => onCommit?.(isNum ? stripComma(val) : val);
  const inputProps = isNum ? { ...rest, type: "text", inputMode: "decimal" } : rest;
  return (
    <input
      {...inputProps}
      value={isNum ? commaView(val) : val}
      onChange={(e) => {
        const raw = isNum ? String(e.target.value).replace(/,/g, "") : e.target.value;
        if (isNum && raw !== "" && !/^-?\d*\.?\d*$/.test(raw)) return; // 숫자/./- 만
        setVal(raw);
        onChangeProp?.(e); // ★ 외부 onChange(e) 가 있으면 함께 호출
      }}
      onBlur={commit}
      onKeyDown={(e)=>{ if (e.key === "Enter") e.currentTarget.blur(); }}
    />
  );
}






// --- 통합검색 유효성 검사 유틸리티 ---
// [규칙] 숫자만 입력: 2자리 이상 / 문자 또는 기호 포함: 1자 이상 / 빈값: 전체조회 허용
function isValidSearchQuery(val) {
  const t = String(val ?? "").trim();
  if (t === "") return true;             // 빈칸은 전체 검색으로 허용
  if (/^\d+$/.test(t)) return t.length >= 2; // 숫자만 포함된 경우 2자리 이상
  return t.length >= 1;                  // 문자/기호 포함 시 1자 이상
}
// [설명] 유효하지 않을 때 사용자에게 보여줄 안내 문구 반환
function getSearchValidationMsg(val) {
  const t = String(val ?? "").trim();
  if (t === "") return null;
  if (/^\d+$/.test(t) && t.length < 2) return "숫자만 입력 시 2자리 이상 입력해 주세요.";
  return null;
}

// --- 유틸리티 및 상수 ---
function localDateISO(d = new Date()) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function todayISO() {
  return localDateISO(new Date());
}

function sixMonthsAgoISO() {
  const d = new Date();
  d.setMonth(d.getMonth() - 6);
  return localDateISO(d);
}

// 수정일 기본 범위
function defaultUpdateDateRange() {
  return { 
    update_date_from: sixMonthsAgoISO(), 
    update_date_to: todayISO(), 
    all_dates: "" 
  };
}
const ESTATE_TYPE_LABELS = { residence: "주거용", profit: "수익성", business: "업무용", commerce: "상업용" };
// ▼▼▼ UI 1개 체크로 두 코드를 동시에 제어 - 빌라 선택 시 데이터컬럼에서 bld_type이 multi_house와 villa 모두 '빌라'로 출력 및 검색
const BLD_GROUPS = [
  { label: "빌라", codes: ["multi-house", "villa"] },
];
// ▼▼▼ 그룹에 포함된 코드들은 개별 렌더링에서 제외 - 빌라 선택 시 데이터컬럼에서 bld_type이 multi_house와 villa 모두 '빌라'로 출력 및 검색
const GROUPED_CODES = new Set(BLD_GROUPS.flatMap(g => g.codes));

const DEFAULT_CENTER = { lat: 37.5665, lng: 126.9780, level: 4 };
const DEFAULT_PAGE_SIZE = 20;

const modernCardStyle = {
  backgroundColor: "#fff",
  borderRadius: "12px",
  padding: "24px",
  boxShadow: "0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06)",
  border: "1px solid #e2e8f0"
};

const modernTitleStyle = {
  fontSize: "16px",
  fontWeight: "700",
  color: "#0f172a",
  margin: "0 0 4px 0",
  letterSpacing: "-0.02em"
};

const modernSubTitleStyle = {
  fontSize: "13px",
  color: "#64748b",
  margin: 0
};

const primaryButtonStyle = {
  backgroundColor: "#130869", // 로고 색상과 통일
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  padding: "8px 16px",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer",
  transition: "all 0.2s"
};

const secondaryButtonStyle = {
  backgroundColor: "#fff",
  color: "#475569",
  border: "1px solid #cbd5e1",
  borderRadius: "6px",
  padding: "8px 16px",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer"
};

const modernCheckboxLabelStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  padding: "8px",
  borderRadius: "6px",
  transition: "background 0.2s",
  backgroundColor: "#fff"
};

const modernCheckboxStyle = {
  width: "16px",
  height: "16px",
  accentColor: "#130869"
};

const modernRadioStyle = {
  padding: "6px 12px",
  borderRadius: "20px",
  border: "1px solid #cbd5e1",
  fontSize: "12px",
  cursor: "pointer",
  color: "#64748b"
};

const modernRadioActiveStyle = {
  ...modernRadioStyle,
  backgroundColor: "#130869",
  color: "#fff",
  borderColor: "#130869"
};


// [FILTER_MEMO_V1] 주차 유료 필터 유틸.
// 인자 v 만 보고 계산하는 순수 함수라 컴포넌트 밖에 두었다.
// 여기 있으면 렌더마다 재생성되지 않으므로 feeOK 의 useCallback deps 에 넣을 필요가 없다.
const num = (v) => {
    const n = Number(String(v ?? "").replace(/[, ]/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

export default function App() {
  console.log("DEV MODE CONFIRMED");
  console.log("🔥 App component executed");
  const { expSoon } = useAuthGuard();
  const [loginOpen, setLoginOpen] = useState(false);
  const [pickedEstate, setPickedEstate] = useState(null);
  const [searchResetKey, setSearchResetKey] = useState(0);

  // --- 상태 관리 ---
  const [mapsReady, setMapsReady] = useState(false);
  const [tab, setTab] = useState(() => {
    // 페이지 최초 로드 시 URL 해시(#search 등)를 읽어서 초기 탭 결정
    // 예) 브라우저 주소창이 /#support 이면 참고 탭으로 시작
    const hash = window.location.hash.slice(1); // "#support" → "support"
    const validTabs = ["search", "support", "manage", "settings"];
    return validTabs.includes(hash) ? hash : "search";
  });

  // 등급관리 상태
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedGrade, setSelectedGrade] = useState('');
  const [gradeMsg, setGradeMsg] = useState('');
  const [userData, setUserData] = useState(null);  // ← 이 줄 추가!


  // ★ 헤더 네비 메뉴 클릭 시 URL 해시가 바뀌면 탭도 자동 전환
  //   (예: 헤더에서 "참고" 클릭 → URL이 /#support 로 변경 → 이 코드가 감지 → tab="support" 로 변경)
  useEffect(() => {
    const onHashChange = () => {
      const hash = window.location.hash.slice(1); // "#support" → "support"
      const validTabs = ["search", "support", "manage", "settings"];
      if (validTabs.includes(hash)) {
        setTab(hash);
      } else if (!hash && window.location.pathname === "/") {
        setTab("search"); // 해시 없이 "/" 접속하면 기본 탭(지도)으로
      }
    };
    window.addEventListener("hashchange", onHashChange);
    onHashChange(); // 처음 로드 시에도 실행
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []); // 빈 배열: 컴포넌트 마운트 시 한 번만 등록

  // ★ userData 초기화
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // JWT token을 디코드 (payload 추출)
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUserData(payload);
        console.log('userData from token:', payload);
      } catch (error) {
        console.error('Token decode failed:', error);
      }
    }
  }, []);

  // 설정 탭 내 서브 메뉴 상태 ("sms-receivers" | "backup")
  const [settingsSubTab, setSettingsSubTab] = useState("sms-receivers");
  const [manageMsg, setManageMsg] = useState(""); // ★ 관리페이지 메시지 상태
  // 수정일 기본값: 시작=6개월 전, 종료=오늘
  const [filters, setFilters] = useState({
    ...DEFAULT_FILTERS,
    ...defaultUpdateDateRange(),
  });


  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  // const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER);
  // [추가] 통합검색 6개월 스위치 상태
  const [locationQuery, setLocationQuery] = useState(""); //★AddressSearch 관련
  const [isIntegratedSixMonth, setIsIntegratedSixMonth] = useState(true);
  const [mapCenter, setMapCenter] = useState(() => {
    try {
      const s = localStorage.getItem("homeCenter");
      return s ? JSON.parse(s) : DEFAULT_CENTER;
    } catch { return DEFAULT_CENTER; }
  });

  // [MAP_CENTER_SYNC_V1] 개인 설정이 없으면 서버의 기본 지역을 따른다.
  //   관리 → 물건접수 지역 설정에서 '기본'으로 고른 구의 좌표를 쓴다.
  //   새 기기나 직원 폰에서도 같은 위치로 시작하게 하려는 것.
  useEffect(() => {
    // [CENTER_PRIORITY_V2] 서버 설정을 우선한다.
    //   브라우저에 남은 옛 값보다 관리탭 설정이 항상 이기도록 한 것.
    const tk = localStorage.getItem("token");
    if (!tk) return;                                   // 비로그인은 기본값 사용
    fetch("/api/staff-intake/region", {
      headers: { Authorization: `Bearer ${tk}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        const c = j?.region?.center;
        if (c?.lat && c?.lng) {
          window.__centerFromServer = true;   // [CENTER_DUP_V1]
          setMapCenter({ lat: c.lat, lng: c.lng, level: c.level || 5 });
        }
      })
      .catch(() => {});   // 실패해도 기본값으로 동작한다
  }, []);
  const listRef = useRef(null);

  // 로컬스토리지 → 초기 노출 상태
  const initialVis =
    JSON.parse(localStorage.getItem("filter_visibility") || "null") ||
    FILTER_VISIBILITY_DEFAULTS;

  const [filtersState, dispatch] = React.useReducer(filtersReducer, {
    values: { ...DEFAULT_FILTERS },
    visibility: initialVis
  });

  const openEditorNew = React.useCallback((estateStub) => {
    setEditorMode("edit");        // 신규도 edit 모드
    setEditorEstate(estateStub);  // estate_no 없음 OK
    setEditorOpen(true);          // 🔥 핵심
  }, []);

  const handleNewRegister = () => {
      if (!window.daum?.Postcode) {
        alert("카카오 주소검색 API가 로드되지 않았습니다.");
        return;
      }

      new window.daum.Postcode({
        oncomplete: async (data) => {
          const jibun = data.jibunAddress?.trim();
          const road = data.roadAddress?.trim();
          const addressText = jibun || road;

          if (!addressText) {
            alert("주소를 확인할 수 없습니다.");
            return;
          }

          try {
            const res = await fetch(`/api/address/normalize?q=${encodeURIComponent(addressText)}`);
            const json = await res.json();

            if (!json?.ok || !json.items?.[0]) {
              alert("지번 정보가 부족하여 신규등록할 수 없습니다.");
              return;
            }

            const item = json.items[0];
            const newEstate = {
              estate_no: null,
              roadAddress: item.roadAddress || road,
              jibunAddress: item.jibunAddress || jibun,
              lat: item.lat,
              lng: item.lng,
              estate_type: "residence",
            };
            openEditorNew(newEstate);
          } catch (e) {
            console.error(e);
            alert("주소 처리 중 오류가 발생했습니다.");
          }
        },
      }).open();
    };

  // 예: 검색 실행 시 쿼리 빌드 (값이 비어있으면 제외)
  const buildQuery = React.useCallback(() => {
    const v = filtersState.values;
    const q = {};
    for (const [k, val] of Object.entries(v)) {
      if (val !== "" && val != null) q[k] = val;
    }
    const usp = new URLSearchParams(q);
    return `/api/properties?${usp.toString()}`;
  }, [filtersState.values]);

  // 추가
  const handleSearch = React.useCallback(() => {
    const url = buildQuery();
    console.log("[SEARCH]", url);
    // 여기에 리스트/맵 로딩 로직 연결
    // loadProperties(url) 또는 setApiUrl(url)
  }, [buildQuery]);

  const handleReset = () => {
    dispatch({ type: "SET_FILTERS", payload: { ...DEFAULT_FILTERS } });
  };

  const moveToEstate = useCallback((p) => {
    if (!p?.lat || !p?.lng) return;
    setMapCenter({
      lat: Number(p.lat),
      lng: Number(p.lng),
      level: 3,
    });
  }, []);

  // === 공통 선택 처리: 리스트 최상단 + 하이라이트 + 지도이동 ===
  const selectEstate = useCallback((estate) => {
    if (!estate?.estate_no) return;

    const id = Number(estate.estate_no);
    setHighlightedId(id);

    setItems(prev => {
      const rest = prev.filter(p => Number(p.estate_no) !== id);
      return [estate, ...rest];
    });

    moveToEstate(estate);
    listRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [moveToEstate]);

  // 썸네일 즉시 업데이트를 위한 함수 (기존 PropertyList에 있던 로직을 App 수준으로 끌어올림)
  const handleThumbUpdate = useCallback((estate_no, newUrl) => {
    // 🔧 [수정 2026] setProperties → setItems
    //   PropertyList.js 에 있던 로직을 App.js 로 옮기면서 변수명을 안 바꿨음
    //   App.js 의 매물 상태는 672줄 const [items, setItems] = useState([])
    //   → 사진 업로드 시 "setProperties is not defined" 오류가 나던 원인
    setItems(prev => 
      prev.map(p => Number(p.estate_no) === Number(estate_no) ? { ...p, thumb_url: newUrl } : p)
    );
    // 🔧 [제거] if (setThumbVer) setThumbVer(...)
    //   setThumbVer 는 PropertyList.js 내부 상태이며 App.js 에는 존재하지 않음
    //   선언되지 않은 이름은 if 조건 검사만으로도 오류가 발생하므로 삭제
    //   썸네일 갱신은 위 setItems 로 thumb_url 이 바뀌면 자동 반영됨
  }, []);


  // 단위변환 상태
  const [sqm, setSqm] = useState("");      // ㎡ 입력값(문자열)
  const [pyeong, setPyeong] = useState(""); // 평 입력값(문자열)

  const toNum = (s) => {
    const n = parseFloat(String(s).replace(/[, ]/g, ""));
    return Number.isFinite(n) ? n : null;
  };

  // ㎡ → 평: 평 소수점 2자리
  const onSqmChange = (e) => {
    const v = e.target.value;
    setSqm(v);
    const n = toNum(v);
    if (n === null) return setPyeong("");
    setPyeong((n / 3.305785).toFixed(2));
  };


  // 평 → ㎡: 정수만
  const onPyeongChange = (e) => {
    const v = e.target.value;
    setPyeong(v);
    const n = toNum(v);
    if (n === null) return setSqm("");
    setSqm(String(Math.floor(n * 3.305785)));
  };

  // === AddressSearch 출력결과 클릭시 리스트 상단이동 조건 예외 로직 2026.01.02 ===
  // const [addressPickedItem, setAddressPickedItem] = useState(null); //★AddressSearch관련
  // const [forcedItem, setForcedItem] = useState(null); //★AddressSearch관련

  // 앱 시작 후에도 한 번 더 보정(파싱 실패 대비)
  // [CENTER_DUP_V1] 단, 서버(관리탭 물건접수 지역 설정)에서 받은 값이
  //   이미 적용됐으면 덮어쓰지 않는다. 두 설정이 다투는 것을 막는다.
  useEffect(() => {
    if (window.__centerFromServer) return;
    try {
      const s = localStorage.getItem("homeCenter");
      if (s) setMapCenter(JSON.parse(s));
    } catch {}
  }, []);

  const [items, setItems] = useState([]);
  const [mapItems, setMapItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  // [통합검색] 입력창에 타이핑 중인 값을 실시간으로 추적하는 상태
  // → 키워드검색 버튼 클릭 시, 아직 blur/Enter를 안 한 값도 가져오기 위해 필요
  const [searchInputVal, setSearchInputVal] = useState(filters.q ?? "");
  // filters.q가 외부에서 바뀔 때(초기화 등) 입력창 값도 맞춰줌
  useEffect(() => { setSearchInputVal(filters.q ?? ""); }, [filters.q]);

  // [통합검색] 검색 대상 컬럼 선택 상태
  // "all"     → 전체 컬럼 검색 (주소·건물명·메모·임대인·임차인)
  // "address" → 주소/건물명만 검색
  // "memo"    → 메모만 검색
  // "owners"  → 임대인(owners)만 검색
  // "tenants" → 임차인(tenants)만 검색
  // → buildParams()에서 q_col 파라미터로 서버에 전달됨
  const [searchCol, setSearchCol] = useState("all");
  const [visibleSections, setVisibleSections] = useState({ 
    region:true, 
    register_date:true, 
    update_date:true, 
    estate_type:true, 
    bld_type:true, 
    parking_paid: true, 
    rent_types:true, 
    use_yn:true, 
    contract_yn:true, 
    mortgage_yn:true,
    bld_structure:true, 
    grade_condition:true, 
    completion_year:true,
    facility: "시설상태",
    owner: "주인세대",
    search:true });

    // ✅ 여기에 SECTION_LABELS 선언
  const SECTION_LABELS = {
    region:"지역",
    register_date: "등록일",
    update_date: "수정일",
    estate_type: "용도",
    bld_type: "종류",
    rent_types: "거래유형",
    bld_structure:"형태구분", 
    grade_condition:"물건관리", 
    use_yn:"삭제데이터", 
    contract_yn:"계약가능", 
    mortgage_yn:"근저당제외",
    parking_paid: "주차(유료)",
    completion_year:"준공일",
    search: "기타검색",
    price: "금액",
    facility: "시설상태",
    owner: "주인세대",
  };

  const [highlightedId, setHighlightedId] = useState(null);
  // [TOUR_SAVE_V1] 안내내역 저장용 — 체크한 매물 객체 배열
  const [checkedProps, setCheckedProps] = useState([]);
  const [showTourSave, setShowTourSave] = useState(false);
  const [hoListOpen, setHoListOpen] = useState(false);
  const [hoListItems, setHoListItems] = useState([]);


  // ✅ 지도용 데이터 소스 단일화 + 배열 보정
  const sourceItemsForMap = useMemo(() => {
    if (Array.isArray(mapItems) && mapItems.length > 0) return mapItems;
    if (Array.isArray(items)) return items;
    return [];
  }, [mapItems, items]);

  const addressGroups = useMemo(() => {
    return groupByAddress(sourceItemsForMap);
  }, [sourceItemsForMap]);

  // const [pickedEstate, setPickedEstate] = useState(null);   // AddressSearch 선택값 //★AddressSearch관련
  // const [searchResetKey, setSearchResetKey] = useState(0);  // AddressSearch 초기화용 키 //★AddressSearch관련
  const [showFilters, setShowFilters] = useState(true);

  // === EstateEditor 오버레이 ===
  const [editorOpen, setEditorOpen] = useState(false);
  const [editorMode, setEditorMode] = useState("edit"); // "edit" | "copy" | "contract"
  const [editorEstate, setEditorEstate] = useState(null);

  const openEditor = React.useCallback(async (mode, estateNo) => {
    if (!estateNo) {
      alert("매물 번호(estate_no)가 없습니다.");
      return;
    }

    // ★ 1. 창부터 즉시 띄우기 (UX 개선 핵심)
    setEditorMode(mode);
    setEditorOpen(true);
    
    // 이전에 남아있던 데이터가 보이지 않게 초기화 (선택 사항)
    // setEditorEstate(null); 

    try {
      // ★ 2. 데이터는 배경에서 비동기로 호출
      const res = await getPropertyById(estateNo);

      if (!res?.item?.estate_no) {
        alert("상세 매물 데이터를 불러오지 못했습니다.");
        setEditorOpen(false); // 로드 실패 시 다시 닫음
        return;
      }

      // ★ 3. 로드 완료된 데이터 주입 (에디터가 자동으로 갱신됨)
      setEditorEstate(res.item); 
    } catch (e) {
      console.error("[openEditor error]", e);
      alert("매물 조회 중 오류 발생");
      setEditorOpen(false);
    }
  }, []);

  const closeEditor = React.useCallback(() => {
    setEditorOpen(false);
    setPickedEstate(null); 
    setSearchResetKey((v) => v + 1);   // 에디터 닫힐 때 검색창 리셋
  }, []);

  // === 우측 패널 열림/탭/투명도 ===
  const [panelOpen, setPanelOpen] = useState(false); // 기본 숨김
  // [PANEL_OUTSIDE_CLOSE_V1] 필터 패널 바깥을 누르면 자동으로 닫기
  //  - 패널(aside.overlay-panel, OverlayPanel 함수가 그림) 안을 누르면 무시
  //  - 「패널열기/닫기」 버튼(data-panel-toggle)은 버튼 자체 onClick 이 토글하므로 무시
  //    → 여기서 닫고 버튼이 다시 여는 '닫기 버튼 먹통' 방지
  //  - pointerdown = 마우스 클릭 + 폰 터치. 누르는 '순간'의 위치로 판정하므로
  //    패널 안에서 슬라이더를 끌다 손이 밖으로 나가도 닫히지 않음
  //  - 세 번째 인자 true(capture): 카카오 지도처럼 이벤트를 막는 요소보다 먼저 받기 위함
  //  - 패널이 열려 있을 때만 감시 → 닫혀 있을 땐 아무 비용 없음
  useEffect(() => {
    if (!panelOpen) return;
    const onDown = (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest(".overlay-panel")) return;      // 패널 안
      if (t.closest("[data-panel-toggle]")) return; // 패널열기 버튼(배지 포함)
      setPanelOpen(false);
    };
    document.addEventListener("pointerdown", onDown, true);
    return () => document.removeEventListener("pointerdown", onDown, true);
  }, [panelOpen]);

  // [SLIDER_PILOT_V1] 슬라이더 범위/단위 설정.
  // 관리탭에서 저장한 값을 서버(app_config)에서 한 번만 읽어와 보관한다.
  // ⚠ 이 객체를 매 렌더 새로 만들면 슬라이더 손잡이가 초기화되므로 state 에 담아둔다.
  const [sliderCfg, setSliderCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch("/api/slider-config")
      .then(r => r.json())
      .then(d => { if (alive) setSliderCfg(d.slider_config || null); })
      .catch(() => {}); // 실패해도 기존 숫자 입력칸으로 자동 대체되므로 무시
    return () => { alive = false; };
  }, []);
  const [mapExpanded, setMapExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // 화면 폭이 768px 이하면 모바일로 간주. 모바일에서만 지도를 작게(16vh) 시작하고,
  // PC(768px 초과)에서는 기존처럼 큰 지도를 그대로 보여줌.

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // 창 크기가 바뀔 때마다(예: 모바일 가로/세로 전환, 브라우저 창 크기 조절) isMobile 값을 갱신

  // 지도 확장/축소 상태. false면 지도 작게(리스트 위주), true면 지도 크게.
  // 기본값 false로 둬서 처음 들어왔을 때 리스트가 잘 보이도록 함.
  const [overlayTab, setOverlayTab] = useState("filter"); // "filter" | "etc"
  const [overlayOpacity, setOverlayOpacity] = useState(1); // 1 → 0.8 → 0.6 → 0.4

  useEffect(() => {
    document.documentElement.style.setProperty("--overlay-opacity", String(overlayOpacity));
  }, [overlayOpacity]);
  const cycleOpacity = () => {
    const ladder = [1, 0.8, 0.6, 0.4];
    const i = ladder.indexOf(overlayOpacity);
    setOverlayOpacity(ladder[(i + 1) % ladder.length]);
  };
  const [isRentTypeAnd, setRentTypeAnd] = useState(false); // ★ '복합거래' AND 조건 상태
  const [completionDateFrom, setCompletionDateFrom] = useState("");
  const [completionDateTo, setCompletionDateTo] = useState("");
  const [managementType, setManagementType] = useState("");
  const [completionYearRange, setCompletionYearRange] = useState([0,100]);
  const [completionYearRangeLocal, setCompletionYearRangeLocal] = React.useState(completionYearRange);
  React.useEffect(()=>{ setCompletionYearRangeLocal(completionYearRange); }, [completionYearRange]);

  // 복원
  React.useEffect(() => {
    try {
      const v = JSON.parse(localStorage.getItem(VIS_KEY) || "null");
      if (v) dispatch({ type: "SET_VIS_ALL", payload: v });
      const vals = JSON.parse(localStorage.getItem(VAL_KEY) || "null");
      if (vals) dispatch({ type: "SET_FILTERS", payload: vals });
    } catch {}
  }, []);

  // 저장
  React.useEffect(() => {
    localStorage.setItem(VIS_KEY, JSON.stringify(filtersState.visibility));
  }, [filtersState.visibility]);
  React.useEffect(() => {
    localStorage.setItem(VAL_KEY, JSON.stringify(filtersState.values));
  }, [filtersState.values]);
  
  const getId = (p) => p?.id ?? p?.estate_no;
  const findById = (id, list) => (list || []).find(p => getId(p) === id);
  
  //사진 소스선택
  const [photoSource, setPhotoSource] = React.useState(
    localStorage.getItem("photo_source") || "server"
  );
  React.useEffect(() => {
    localStorage.setItem("photo_source", photoSource);
  }, [photoSource]);


   // Kakao SDK 준비되면 지도 렌더 시작
 useEffect(() => {
  const K = window?.kakao?.maps;
  console.log("[APP] kakao.maps =", K);
  if (!K) return;                          // SDK 태그 미로딩 시 조용히 대기
  if (typeof K.load === "function") {
    K.load(() => { console.log("[APP] maps.load done"); setMapsReady(true); });      // ★ autoload=false 대응: 로드 완료 후 true
    return;
  }
  if (typeof K.LatLng === "function") {
    console.log("[APP] LatLng already available");                  // autoload=true 또는 이미 로드된 경우
    setMapsReady(true);
  }
 }, []);

  const buildParams = useCallback((forMap = false) => {
    const p = forMap ? { ...filters, pageSize: 'all' } : { ...filters, page, pageSize };

  const hasQ = p.q && String(p.q).trim() !== "";

  if (hasQ) {
    // 🔥 q 검색 시 날짜/연도 관련 파라미터 전부 제거
    delete p.update_date_from;
    delete p.update_date_to;
    delete p.all_dates;
    delete p.completion_year_min;
    delete p.completion_year_max;
    delete p.completion_year_from;
    delete p.completion_year_to;
    delete p.completionDateFrom;
    delete p.completionDateTo;
    delete p.completionYearRange;
  }

    if (isRentTypeAnd) p.rent_type_and = "y"; // ★ AND 조건일 때 파라미터 추가
    if (managementType) p.grade_condition = managementType;

    // [추가] 통합검색 시 6개월 필터 값 전달
    if (p.q) p.six_month = isIntegratedSixMonth ? 'y' : 'n';

    // [추가] 검색 대상 컬럼 전달
    // searchCol이 "all"이 아닐 때만 q_col 파라미터를 추가하여 서버에 전달
    // 예) q_col=owners  이면 서버는 owners(임대인) 컬럼만 검색
    // 예) q_col=tenants 이면 서버는 tenants(임차인) 컬럼만 검색
    // q_col을 생략하면 서버는 기본값(전체 컬럼) 검색
    if (p.q && searchCol && searchCol !== "all") {
      p.q_col = searchCol;
    }
    if (p.estate_type?.length) p.estate_type = p.estate_type.join(",");
    if (p.bld_type?.length) p.bld_type = p.bld_type.join(",");
    // ★ 소재지 검색 추가
    if (locationQuery.trim()) p.addr_like = locationQuery.trim();

  if (!hasQ) {
    // q 없을 때만 날짜/연도 조건 생성
    if (Array.isArray(completionYearRange)) {
      const [lo, hi] = completionYearRange;
      const CUR = new Date().getFullYear();
      p.completion_year_min = CUR - (typeof hi === "number" ? hi : 100);
      p.completion_year_max = CUR - (typeof lo === "number" ? lo : 0);
      delete p.completion_year;
    }
    if (completionDateFrom) p.completion_year_from = completionDateFrom;
    if (completionDateTo)   p.completion_year_to   = completionDateTo;
  }

    // 불린 플래그
    if (p.sale_type_sub_rent)   p.sale_type_sub_rent   = "y"; else delete p.sale_type_sub_rent;
    if (p.sale_type_sub_living) p.sale_type_sub_living = "y"; else delete p.sale_type_sub_living;
    if (p.owner_household)      p.owner_household      = "y"; else delete p.owner_household;

    // 시설상태 → 개별 키로 분해
    if (Array.isArray(p.facility)) {
    const has = (k)=>p.facility.includes(k);
    if (has("ev"))        p.living_condition_ev = "y";
    if (has("interior"))  p.internal_condition_interior = "y";
    if (has("water"))     p.internal_condition_water = "y";
    if (has("city_gas"))  p.internal_condition_city_gas = "y";
    if (has("bath_div"))  p.bath_division = "y";
    if (has("bath_in"))   p.bath_inside = "y";
    if (has("exsign"))    p.external_condition_exsign = "y";
    // heat / cold 값 매핑
    if (has("heat:center"))       p.heat_condition = "center";
    else if (has("heat:floor"))   p.heat_condition = "floor";
    else if (has("heat:private-heat")) p.heat_condition = "private-heat";
    if (has("cold:center"))       p.cold_condition = "center";
    else if (has("cold:private")) p.cold_condition = "private";
    delete p.facility;
  }

// 빈 문자열 정리는 기존 로직 유지

    Object.keys(p).forEach(k => { if (k.startsWith("rent_type_") && p[k]) p[k] = "y"; });

    if (!forMap) delete p.filters;
    // ▼ 빈 값 제거: "" | null | undefined 는 쿼리에서 제외
    Object.keys(p).forEach((k) => {
      const v = p[k];
      if (v === "" || v === null || v === undefined) delete p[k];
    });
    return p;
  }, [page, pageSize, filters, searchCol,
      completionYearRange, isRentTypeAnd,
      completionDateFrom, completionDateTo,
      managementType]);

  const load = useCallback(async () => {
    setLoading(true);
    setHighlightedId(null);
    setMapItems([]);
    try {
      const res = await getProperties(buildParams());
      setItems(res.items || []);
      setTotal(res.total || 0);
    } catch (e) {
      console.error("[LOAD] error:", e);
      setItems([]); setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [buildParams]);

  // 에디터에서 저장 완료되면 리스트 리로드
  const handleEditorSaved = React.useCallback((result) => {
    console.log("[EstateEditor saved]", result);
    // 굳이 페이지 초기화 안 하고, 현재 필터 그대로 다시 로드
    load();
  }, [load]);

  useEffect(() => { load(); }, [load]);

  const loadAllForMap = async () => {
    setLoading(true);
    try {
      const params = buildParams(true);
      const data = await getProperties(params);
      setMapItems(Array.isArray(data) ? data : []);
    } catch (e) { console.error("[LOAD ALL] error:", e); } 
    finally { setLoading(false); }
  };
  
  // AddressSearch에서 선택했을 때: 리스트 최상단으로 이동 + 스크롤 //★AddressSearch관련
  // const handleSearchPick = useCallback((picked) => {
  //   if (!picked || !picked.estate_no) return;
  //     const id = picked.estate_no;     // 검색결과의 estate_no 사용

  //     setHighlightedId(id);

  //     const allItems = mapItems.length > 0 ? mapItems : items;
  //     const clickedItem = findById(id, allItems);
  //     if (clickedItem) {
  //       const newList = items.filter(item => getId(item) !== id);
  //       newList.unshift(clickedItem);     // 맨 위로 올리기
  //       setItems(newList);
  //     }

  //     // 리스트 영역 위로 스크롤
  //     listRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  //   }, [items, mapItems, findById]
  // );

  // AddressSearch → 결과 없음 → "신규등록" 클릭 시 호출
  const handleNewFromAddress = useCallback((keyword) => {
    const addr = (keyword || "").trim();
    if (!addr) return;

    // TODO:
    //  1) addr을 기반으로 새 매물 stub 생성
    //  2) EstateEditor를 "신규등록" 모드로 열고
    //  3) 백엔드에 신규 INSERT까지 연결
    //
    // 현 상태의 EstateEditor는 estate_no 없으면
    //   alert("매물 번호(estate_no)가 없습니다.");
    // 로 막고 있으므로,
    // 신규등록 저장 로직은 다음 단계에서 별도로 구현해야 합니다.
    if (!keyword || typeof keyword !== "object") return;

    const { roadAddress, jibunAddress } = keyword;

    const newEstate = {
      estate_no: null,
      estate_id: null,
      branch_id: null,
      roadAddress,
      jibunAddress,
      detailAddress: "",
    };
    alert("신규 매물 등록은 아직 구현되지 않았습니다.");
return;
  }, []);

  const resetAll = useCallback(() => {
    // 리셋 시에도 수정일 기본 범위를 다시 주입
    setFilters({ ...DEFAULT_FILTERS, ...defaultUpdateDateRange() });
    setPage(1);
    setTab("search");
    setRentTypeAnd(false); // ★ '복합거래' 상태를 false(기본값)로 초기화
  }, []); // <-- 의존성 배열은 비워둬도 괜찮습니다.

  const totalPages = Math.max(Math.ceil(total / (pageSize || 1)), 1);

  function countActiveFilters(f) {
    if (!f) return 0;
    let n = 0;
    if (f.register_date_from || f.register_date_to) n++;
    if (f.update_date_from !== sixMonthsAgoISO() || f.update_date_to !== todayISO()) n++;
    if (f.estate_type?.length > 0) n++;
    if (f.bld_type?.length > 0) n++;
    if (f.parking_paid) n++;              // ← 추가
    Object.keys(f).forEach(k => { if (k.startsWith("rent_type_") && f[k]) n++; });
    if (f.q) n++;
    if (f.use_yn_n) n++;
    if (f.contract_yn_y) n++;
    if (f.mortgage_yn_n) n++;
    if (f.bld_structure?.length>0) n++;
    if (f.grade_condition) n++;
    if (f.completion_age?.[0]!==0 || f.completion_age?.[1]!==100) n++;
    return n;
  }

  const RENT_FILTER_LABELS = {
    rent_type_4deal: "매매",
    rent_type_1year: "전세",
    rent_type_2month: "월세",
    rent_type_3short: "단기",
    rent_type_5sale: "분양",
    rent_type_6auction: "경매",
  };

  function listActiveFilters(f) {
    if (!f) return [];
    const list = [];

    if (f.register_date_from || f.register_date_to)
      list.push("등록일 조건");

    if (
      f.update_date_from !== sixMonthsAgoISO() ||
      f.update_date_to !== todayISO()
    )
      list.push("수정일 조건");

    if (f.estate_type?.length > 0)
      list.push("용도 필터(estate_type)");

    if (f.bld_type?.length > 0)
      list.push("건물유형 필터(bld_type)");

    if (f.parking_paid)
      list.push("유료주차 포함");

    Object.keys(f).forEach((k) => {
      if (k.startsWith("rent_type_") && f[k]) {
        const label = RENT_FILTER_LABELS[k] || k;
        list.push(`거래유형: ${label}`);
      }
    });

    if (f.q)
      list.push("텍스트 검색(q)");

    if (f.use_yn_n)
      list.push("미사용 매물 포함");

    if (f.contract_yn_y)
      list.push("거래완료 매물 포함");

    if (f.mortgage_yn_n)
      list.push("근저당 없는 매물만");

    if (f.bld_structure?.length > 0)
      list.push("구조 필터(bld_structure)");

    if (f.grade_condition)
      list.push("관리형태/등급 필터");

    if (
      f.completion_age?.[0] !== 0 ||
      f.completion_age?.[1] !== 100
    )
      list.push("준공연차 범위 필터");

    return list;
  }

  const activeFilters = countActiveFilters(filters);
  const activeFilterLabels = listActiveFilters(filters);

// ========================== 우측 오버레이 패널 (원본 로직 100% 포함) =========================

const OverlayPanel = ({ inline = false, open = true }) => {
  // 텍스트 링크 버튼 스타일
  const linkButtonStyle = {
    fontSize: '10px', color: '#3b82f6', background: 'none', border: 'none',
    cursor: 'pointer', padding: '0', textDecoration: 'underline', marginLeft: '6px'
  };

  return (
    <aside className={`overlay-panel${inline ? " inline" : ""} ${open ? "is-open" : ""}`}>
      {/* 헤더 섹션 */}
      <div className="overlay-header">
        <div className="overlay-title">검색 필터 설정</div>
        <div className="overlay-actions">
          <button className="btn" onClick={cycleOpacity}>
            투명도 {Math.round(overlayOpacity * 100)}%
          </button>
        </div>
      </div>

      {/* 탭 네비게이션 */}
      <div className="tabs" role="tablist">
        <button
          type="button"
          className={`tab ${overlayTab === "filter" ? "is-active" : ""}`}
          onClick={() => setOverlayTab("filter")}
        >기본필터</button>
        <button
          type="button"
          className={`tab ${overlayTab === "etc" ? "is-active" : ""}`}
          onClick={() => setOverlayTab("etc")}
        >기타설정</button>
      </div>

      <div className="overlay-body">
        {overlayTab === "filter" ? (
          <div key="tab-filter" className="tab-panel" style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            
            {/* 1. 지역 설정 */}
            {visibleSections.region && (
              <section>
                <div className="label">지역 설정</div>
                <RegionSelector 
                  value={mapCenter} 
                  onChange={(center) => { setMapCenter(center); setPage(1); }} 
                />
              </section>
            )}

            {/* 2. 날짜 조건 그룹 */}
            <section style={{ background: '#f8fafc', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
              {visibleSections.register_date && (
                <div style={{ marginBottom: "10px" }}>
                  <div className="label">등록일 범위</div>
                  <div className="range-group">
                    <input type="date" value={filters.register_date_from} onChange={(e) => { setPage(1); setFilters({ ...filters, register_date_from: e.target.value }); }} />
                    <span>~</span>
                    <input type="date" value={filters.register_date_to} onChange={(e) => { setPage(1); setFilters({ ...filters, register_date_to: e.target.value }); }} />
                  </div>
                </div>
              )}
              {visibleSections.update_date && (
                <div>
                  <div className="label">
                    수정일 범위 
                    <button type="button" style={linkButtonStyle} onClick={() => {
                      setPage(1);
                      setFilters((f) => ({ ...f, update_date_from: "", all_dates: "y" }));
                      const sp = new URLSearchParams(window.location.search);
                      sp.delete("update_date_from");
                      sp.set("all_dates", "y");
                      window.history.replaceState(null, "", `?${sp.toString()}`);
                    }}>시작일 초기화</button>
                  </div>
                  <div className="range-group">
                    <input type="date" value={filters.update_date_from ?? ""} onChange={(e) => { setPage(1); setFilters((f) => ({ ...f, update_date_from: e.target.value, all_dates: "" })); }} />
                    <span>~</span>
                    <input type="date" value={filters.update_date_to ?? ""} onChange={(e) => { setPage(1); setFilters((f) => ({ ...f, update_date_to: e.target.value })); }} />
                  </div>
                </div>
              )}
            </section>

            {/* 3. 매물 기본 속성 드롭다운 */}
            <section style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <div className="label">매물 기본 속성</div>
              {visibleSections.estate_type && (
                <MultiDropdown label="용도" options={ESTATE_TYPE_OPTIONS} values={filters.estate_type} onChange={(vals) => { setPage(1); setFilters(f => ({ ...f, estate_type: vals })); }} />
              )}
              {visibleSections.bld_type && (
                <MultiDropdown label="종류" options={BLD_TYPE_OPTIONS} values={filters.bld_type} onChange={(vals) => { setPage(1); setFilters(f => ({ ...f, bld_type: vals })); }} />
              )}
              {visibleSections.rent_types && (
                <div className="range-group">
                  <div style={{ flex: 1 }}>
                    <MultiDropdown label="거래유형" options={RENT_TYPE_OPTIONS} values={filters.rent_types} onChange={(vals) => { setPage(1); setFilters(f => ({ ...f, rent_types: vals })); }} />
                  </div>
                  <button className="btn" onClick={() => setRentTypeAnd(!isRentTypeAnd)} style={{ height: '30px', padding: '0 6px', fontSize: '12px', backgroundColor: isRentTypeAnd ? '#3b82f6' : '#fff', color: isRentTypeAnd ? '#fff' : '#444' }}>
                    복합(AND)
                  </button>
                </div>
              )}
              {visibleSections.bld_structure && (
                <MultiDropdown label="형태구분" options={BLD_STRUCTURE_OPTIONS} values={filters.bld_structure} onChange={(vals) => { setPage(1); setFilters(f => ({ ...f, bld_structure: vals })); }} />
              )}
              {visibleSections.grade_condition && (
                <SingleDropdown label="물건관리" options={GRADE_CONDITION_OPTIONS} value={filters.grade_condition} onChange={(val) => { setPage(1); setFilters(f => ({ ...f, grade_condition: val })); }} />
              )}
              {visibleSections.facility && (
                <MultiDropdown label="시설상태" options={FACILITY_OPTIONS} values={filters.facility} onChange={(vals) => setFilters(f => ({ ...f, facility: vals }))} />
              )}
            </section>

            {/* 4. 키워드 및 수량 검색 */}
            {visibleSections.search && (
              <section style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div className="label">상세 검색 및 수치</div>
                <BlurCommitInput type="text" placeholder="지번/도로명/메모/연락처 키워드" value={filters.q ?? ""} onCommit={(val) => { setPage(1); setFilters(f => ({ ...f, q: val })); }} />
                
                {/* 룸/욕실 */}
                <div className="range-group">
                  <div style={{flex:1}}>
                    <div style={{fontSize:'12px', color:'#94a3b8'}}>룸수</div>
                    {/* [SLIDER_PILOT_V1] 슬라이더 시범 적용.
                        설정을 못 불러왔거나 칸이 2개 미만이면 기존 숫자 입력칸을 그대로 쓴다.
                        (서버 장애 시에도 필터가 먹통이 되지 않게 하려는 안전장치) */}
                    {sliderCfg?.room_cnt && buildStops(sliderCfg.room_cnt).length > 1 ? (
                      <RangeSlider
                        config={sliderCfg.room_cnt}
                        minValue={filters.room_cnt_min ?? ""}
                        maxValue={filters.room_cnt_max ?? ""}
                        onCommit={(lo, hi) => {
                          setPage(1);
                          setFilters(f => ({ ...f, room_cnt_min: lo, room_cnt_max: hi }));
                        }}
                      />
                    ) : (
                      <div className="range-group">
                        <BlurCommitInput type="number" placeholder="최소" value={filters.room_cnt_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, room_cnt_min:v})) }} />
                        <span>~</span>
                        <BlurCommitInput type="number" placeholder="최대" value={filters.room_cnt_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, room_cnt_max:v})) }} />
                      </div>
                    )}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:'12px', color:'#94a3b8'}}>욕실수</div>
                    {/* [SLIDER_A_V1] 설정을 못 읽으면 기존 숫자 입력칸으로 자동 대체 */}
                    {sliderCfg?.bath_cnt && buildStops(sliderCfg.bath_cnt).length > 1 ? (
                      <RangeSlider
                        config={sliderCfg.bath_cnt}
                        minValue={filters.bath_cnt_min ?? ""}
                        maxValue={filters.bath_cnt_max ?? ""}
                        onCommit={(lo, hi) => { setPage(1); setFilters(f => ({ ...f, bath_cnt_min: lo, bath_cnt_max: hi })); }}
                      />
                    ) : (
                      <div className="range-group">
                        <BlurCommitInput type="number" placeholder="최소" value={filters.bath_cnt_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, bath_cnt_min:v})) }} />
                        <span>~</span>
                        <BlurCommitInput type="number" placeholder="최대" value={filters.bath_cnt_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, bath_cnt_max:v})) }} />
                      </div>
                    )}
                  </div>
                </div>

                {/* 보증금/월세 */}
                {/* [SLIDER_D_V1] 매매금액 (신규 필터).
                    서버 routes/properties.js 의 [SALE_FILTER_V1] 조건과 짝을 이룬다.
                    이 값을 지정하면 매매 물건이 아닌 매물(price_sale=0)은 결과에서 제외된다. */}
                <div style={{marginBottom:'8px'}}>
                  <div style={{fontSize:'12px', color:'#94a3b8'}}>매매금액(만)</div>
                  {sliderCfg?.fee_sale && buildStops(sliderCfg.fee_sale).length > 1 ? (
                    <RangeSlider
                      config={sliderCfg.fee_sale}
                      minValue={filters.fee_sale_min ?? ""}
                      maxValue={filters.fee_sale_max ?? ""} unit="만"
                      onCommit={(lo, hi) => { setPage(1); setFilters(f => ({ ...f, fee_sale_min: lo, fee_sale_max: hi })); }}
                    />
                  ) : (
                    <div className="range-group">
                      <BlurCommitInput type="number" placeholder="최소" value={filters.fee_sale_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, fee_sale_min:v})) }} />
                      <span>~</span>
                      <BlurCommitInput type="number" placeholder="최대" value={filters.fee_sale_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, fee_sale_max:v})) }} />
                    </div>
                  )}
                </div>
                {/* [SLIDER_A_V1] 보증금·월세는 슬라이더 폭 확보를 위해 한 줄에 하나씩 배치 */}
                <div>
                  <div style={{fontSize:'12px', color:'#94a3b8'}}>보증금(만)</div>
                  {/* [SLIDER_A_V1] 설정을 못 읽으면 기존 숫자 입력칸으로 자동 대체 */}
                  {sliderCfg?.fee_year && buildStops(sliderCfg.fee_year).length > 1 ? (
                    <RangeSlider
                      config={sliderCfg.fee_year}
                      minValue={filters.fee_year_min ?? ""}
                      maxValue={filters.fee_year_max ?? ""} unit="만"
                      onCommit={(lo, hi) => { setPage(1); setFilters(f => ({ ...f, fee_year_min: lo, fee_year_max: hi })); }}
                    />
                  ) : (
                    <div className="range-group">
                      <BlurCommitInput type="number" placeholder="최소" value={filters.fee_year_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, fee_year_min:v})) }} />
                      <span>~</span>
                      <BlurCommitInput type="number" placeholder="최대" value={filters.fee_year_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, fee_year_max:v})) }} />
                    </div>
                  )}
                </div>
                <div style={{marginTop:'8px'}}>
                  <div style={{fontSize:'12px', color:'#94a3b8'}}>월세(만)</div>
                  {/* [SLIDER_A_V1] 설정을 못 읽으면 기존 숫자 입력칸으로 자동 대체 */}
                  {sliderCfg?.fee_month && buildStops(sliderCfg.fee_month).length > 1 ? (
                    <RangeSlider
                      config={sliderCfg.fee_month}
                      minValue={filters.fee_month_min ?? ""}
                      maxValue={filters.fee_month_max ?? ""} unit="만"
                      onCommit={(lo, hi) => { setPage(1); setFilters(f => ({ ...f, fee_month_min: lo, fee_month_max: hi })); }}
                    />
                  ) : (
                    <div className="range-group">
                      <BlurCommitInput type="number" placeholder="최소" value={filters.fee_month_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, fee_month_min:v})) }} />
                      <span>~</span>
                      <BlurCommitInput type="number" placeholder="최대" value={filters.fee_month_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, fee_month_max:v})) }} />
                    </div>
                  )}
                </div>

                {/* 층수 */}
                <div>
                  <div style={{fontSize:'12px', color:'#94a3b8'}}>해당층</div>
                  {/* [SLIDER_A_V1] 설정을 못 읽으면 기존 숫자 입력칸으로 자동 대체 */}
                  {sliderCfg?.floor && buildStops(sliderCfg.floor).length > 1 ? (
                    <RangeSlider
                      config={sliderCfg.floor}
                      minValue={filters.floor_min ?? ""}
                      maxValue={filters.floor_max ?? ""} unit="층" skipZero
                      onCommit={(lo, hi) => { setPage(1); setFilters(f => ({ ...f, floor_min: lo, floor_max: hi })); }}
                    />
                  ) : (
                    <div className="range-group">
                      <BlurCommitInput type="number" placeholder="최소" value={filters.floor_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, floor_min:v})) }} />
                      <span>~</span>
                      <BlurCommitInput type="number" placeholder="최대" value={filters.floor_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, floor_max:v})) }} />
                    </div>
                  )}
                </div>
              </section>
            )}

            {/* 5. 전용/실면적 복합 로직 (변환 로직 100% 복구) */}
            {visibleSections.search && (
              <section style={{ background: '#f1f5f9', padding: '10px', borderRadius: '6px' }}>
                <div className="label">면적 필터 (평 ↔ ㎡ 자동변환)</div>
                {/* 전용면적 */}
                <div style={{ marginBottom: '8px' }}>
                  <div style={{fontSize:'12px', color:'#64748b'}}>전용면적</div>
                  {/* [SLIDER_B_V1] 평 슬라이더 하나로 조작. ㎡ 는 자동 계산되어 아래에 표시만 된다.
                      (기존과 동일하게 filters 의 ㎡ 자리도 함께 채워 서버 동작을 그대로 유지) */}
                  {sliderCfg?.exclusive_scale_square && buildStops(sliderCfg.exclusive_scale_square).length > 1 ? (
                    <>
                      <RangeSlider
                        config={sliderCfg.exclusive_scale_square}
                        minValue={filters.exclusive_scale_square_min ?? ""}
                        maxValue={filters.exclusive_scale_square_max ?? ""} unit="평"
                        onCommit={(lo, hi) => {
                          setPage(1);
                          // 평 2자리 + ㎡ 2자리를 한 번에 갱신
                          const loSqm = lo === "" ? "" : py2sqm(Number(lo));
                          const hiSqm = hi === "" ? "" : py2sqm(Number(hi));
                          setFilters(f => ({ ...f,
                            exclusive_scale_square_min: lo, exclusive_scale_square_max: hi,
                            exclusive_scale_min: loSqm, exclusive_scale_max: hiSqm,
                          }));
                        }}
                      />
                      {/* ㎡ 환산 결과 (읽기 전용) */}
                      <div style={{ fontSize: '11px', color: '#94a3b8', textAlign: 'center' }}>
                        {(filters.exclusive_scale_min || filters.exclusive_scale_max)
                          ? `${filters.exclusive_scale_min || 0} ~ ${filters.exclusive_scale_max || "제한없음"} ㎡`
                          : "㎡ 자동환산"}
                      </div>
                    </>
                  ) : (
                    <div className="range-group">
                      <BlurCommitNumber placeholder="최소평" initial={filters.exclusive_scale_square_min} onCommit={(v)=>{
                        const minPy = toNum(v); setFilters(f => ({ ...f, exclusive_scale_square_min: minPy ?? "", exclusive_scale_min: minPy == null ? "" : py2sqm(minPy) }));
                      }} />
                      <span>~</span>
                      <BlurCommitNumber placeholder="최대평" initial={filters.exclusive_scale_square_max} onCommit={(v)=>{
                        const maxPy = toNum(v); setFilters(f => ({ ...f, exclusive_scale_square_max: maxPy ?? "", exclusive_scale_max: maxPy == null ? "" : py2sqm(maxPy) }));
                      }} />
                    </div>
                  )}
                </div>
                {/* 실면적 */}
                <div>
                  <div style={{fontSize:'12px', color:'#64748b'}}>실면적</div>
                  {/* [SLIDER_B_V1] 평 슬라이더 하나로 조작. ㎡ 는 자동 계산되어 아래에 표시만 된다.
                      (기존과 동일하게 filters 의 ㎡ 자리도 함께 채워 서버 동작을 그대로 유지) */}
                  {sliderCfg?.used_scale_square && buildStops(sliderCfg.used_scale_square).length > 1 ? (
                    <>
                      <RangeSlider
                        config={sliderCfg.used_scale_square}
                        minValue={filters.used_scale_square_min ?? ""}
                        maxValue={filters.used_scale_square_max ?? ""} unit="평"
                        onCommit={(lo, hi) => {
                          setPage(1);
                          // 평 2자리 + ㎡ 2자리를 한 번에 갱신
                          const loSqm = lo === "" ? "" : py2sqm(Number(lo));
                          const hiSqm = hi === "" ? "" : py2sqm(Number(hi));
                          setFilters(f => ({ ...f,
                            used_scale_square_min: lo, used_scale_square_max: hi,
                            used_scale_min: loSqm, used_scale_max: hiSqm,
                          }));
                        }}
                      />
                      {/* ㎡ 환산 결과 (읽기 전용) */}
                      <div style={{ fontSize: '11px', color: '#94a3b8', textAlign: 'center' }}>
                        {(filters.used_scale_min || filters.used_scale_max)
                          ? `${filters.used_scale_min || 0} ~ ${filters.used_scale_max || "제한없음"} ㎡`
                          : "㎡ 자동환산"}
                      </div>
                    </>
                  ) : (
                    <div className="range-group">
                      <BlurCommitNumber placeholder="최소평" initial={filters.used_scale_square_min} onCommit={(v)=>{
                        const minPy = toNum(v); setFilters(f => ({ ...f, used_scale_square_min: minPy ?? "", used_scale_min: minPy == null ? "" : py2sqm(minPy) }));
                      }} />
                      <span>~</span>
                      <BlurCommitNumber placeholder="최대평" initial={filters.used_scale_square_max} onCommit={(v)=>{
                        const maxPy = toNum(v); setFilters(f => ({ ...f, used_scale_square_max: maxPy ?? "", used_scale_max: maxPy == null ? "" : py2sqm(maxPy) }));
                      }} />
                    </div>
                  )}
                </div>
              </section>
            )}

            {/* 6. 준공년도 (프리셋 포함) */}
            {visibleSections.completion_year && (
              <section>
                <div className="label">건물노후기간</div>
                {/* [SLIDER_C_V1] 건물노후기간 슬라이더.
                    다른 필터와 달리 값이 [최소, 최대] 배열 하나로 관리되고,
                    상태가 두 벌(검색용 completionYearRange / 화면용 ...Local)이라 함께 갱신한다.
                    또한 오른쪽 끝은 "제한 없음"을 뜻하는 특수값 100 으로 넣어
                    관리 설정 상한(예: 50년)보다 오래된 건물이 빠지지 않게 한다.
                    프리셋 버튼(2년/4년/10년...)은 슬라이더로 대체되어 제거함. */}
                {sliderCfg?.completion_year && buildStops(sliderCfg.completion_year).length > 1 ? (
                  <RangeSlider
                    config={sliderCfg.completion_year}
                    minValue={completionYearRangeLocal?.[0] ?? ""}
                    maxValue={(completionYearRangeLocal?.[1] ?? 100) >= 100 ? "" : completionYearRangeLocal[1]}
                    unit="년"
                    onCommit={(lo, hi) => {
                      const n = [lo === "" ? 0 : Number(lo), hi === "" ? 100 : Number(hi)];
                      setCompletionYearRangeLocal(n);
                      setCompletionYearRange(n);
                      setPage(1);
                    }}
                  />
                ) : (
                  <div className="range-group">
                    <BlurCommitNumber initial={completionYearRangeLocal?.[0] ?? 0} onCommit={(val) => { const n = [Number(val), completionYearRangeLocal[1]]; setCompletionYearRangeLocal(n); setCompletionYearRange(n); setPage(1); }} />
                    <span>~</span>
                    <BlurCommitNumber initial={completionYearRangeLocal?.[1] ?? 100} onCommit={(val) => { const n = [completionYearRangeLocal[0], Number(val)]; setCompletionYearRangeLocal(n); setCompletionYearRange(n); setPage(1); }} />
                  </div>
                )}
              </section>
            )}

            {/* 7. 매매 서브옵션 & 주인세대 */}
            <section style={{ borderTop: '1px dashed #ddd', paddingTop: '10px' }}>
              <div className="label">매매 및 주인세대 상세</div>
              <div className="checkbox-group">
                <label><input type="checkbox" checked={!!filters.sale_type_sub_rent} onChange={e=>setFilters(f=>({...f, sale_type_sub_rent:e.target.checked}))}/> 임대승계</label>
                <label><input type="checkbox" checked={!!filters.sale_type_sub_living} onChange={e=>setFilters(f=>({...f, sale_type_sub_living:e.target.checked}))}/> 입주가능</label>
                <label><input type="checkbox" checked={!!filters.owner_household} onChange={e => setFilters(f => ({ ...f, owner_household: e.target.checked ? "y" : "" }))} /> 주인세대포함</label>
              </div>
<div className="range-group" style={{ marginTop: '10px' }}>
  {/* 왼쪽: 주인룸수 (일반 룸수와 동일한 구조) */}
  <div style={{ flex: 1 }}>
    <div style={{ fontSize: '12px', color: '#94a3b8' }}>주인룸수</div>
    {/* [SLIDER_A_V1] 설정을 못 읽으면 기존 숫자 입력칸으로 자동 대체 */}
    {sliderCfg?.owner_room && buildStops(sliderCfg.owner_room).length > 1 ? (
      <RangeSlider
        config={sliderCfg.owner_room}
        minValue={filters.owner_room_min ?? ""}
        maxValue={filters.owner_room_max ?? ""}
        onCommit={(lo, hi) => { setPage(1); setFilters(f => ({ ...f, owner_room_min: lo, owner_room_max: hi })); }}
      />
    ) : (
      <div className="range-group">
        <BlurCommitInput type="number" placeholder="최소" value={filters.owner_room_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, owner_room_min:v})) }} />
        <span>~</span>
        <BlurCommitInput type="number" placeholder="최대" value={filters.owner_room_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, owner_room_max:v})) }} />
      </div>
    )}
  </div>

  {/* 오른쪽: 주인욕실수 (일반 욕실수와 동일한 구조) */}
  <div style={{ flex: 1 }}>
    <div style={{ fontSize: '12px', color: '#94a3b8' }}>주인욕실수</div>
    {/* [SLIDER_A_V1] 설정을 못 읽으면 기존 숫자 입력칸으로 자동 대체 */}
    {sliderCfg?.owner_bath && buildStops(sliderCfg.owner_bath).length > 1 ? (
      <RangeSlider
        config={sliderCfg.owner_bath}
        minValue={filters.owner_bath_min ?? ""}
        maxValue={filters.owner_bath_max ?? ""}
        onCommit={(lo, hi) => { setPage(1); setFilters(f => ({ ...f, owner_bath_min: lo, owner_bath_max: hi })); }}
      />
    ) : (
      <div className="range-group">
        <BlurCommitInput type="number" placeholder="최소" value={filters.owner_bath_min ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, owner_bath_min:v})) }} />
        <span>~</span>
        <BlurCommitInput type="number" placeholder="최대" value={filters.owner_bath_max ?? ""} onCommit={(v)=>{ setPage(1); setFilters(f=>({...f, owner_bath_max:v})) }} />
      </div>
    )}
  </div>
</div>
            </section>

            {/* 8. 고정 체크박스 그룹 */}
            <section>
              <div className="label">기타 필터 옵션</div>
              <div className="checkbox-group">
                {visibleSections.use_yn && <label><input type="checkbox" checked={filters.use_yn_n} onChange={e => { setPage(1); setFilters(f => ({ ...f, use_yn_n: e.target.checked })); }} /> 삭제데이터</label>}
                {visibleSections.contract_yn && <label><input type="checkbox" checked={filters.contract_yn_y} onChange={e => { setPage(1); setFilters(f => ({ ...f, contract_yn_y: e.target.checked })); }} /> 계약가능</label>}
                {visibleSections.mortgage_yn && <label><input type="checkbox" checked={filters.mortgage_yn_n} onChange={e => { setPage(1); setFilters(f => ({ ...f, mortgage_yn_n: e.target.checked })); }} /> 근저당제외</label>}
                {visibleSections.parking_paid && <label><input type="checkbox" checked={filters.parking_paid} onChange={e => { setPage(1); setFilters(f => ({ ...f, parking_paid: e.target.checked })); }} /> 유료주차</label>}
              </div>
            </section>

            <section>
              <div className="label">출력 설정</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '4px' }}>
                <span style={{ fontSize: '12px' }}>페이지당 매물:</span>
                <select 
                  value={pageSize} 
                  onChange={(e) => { 
                      const v = Number(e.target.value);
                      setPageSize(v); 
                      setPage(1); 
                      fetch("/api/app-config", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ page_size: v }),
                      });
                    }} 
                  style={{ height: '30px', flex: 1 }}>
                  {[10, 20, 50, 100, 200, 500, 1000].map(n => <option key={n} value={n}>{n}개씩</option>)}
                </select>
              </div>
            </section>

            <section style={{ marginTop: '20px' }}>
              <div className="label">거래 모드 토글</div>
              <button className="btn" style={{ width: '100%', height: '34px' }} onClick={() => setRentTypeAnd(v => !v)}>
                복합거래(AND) 모드: {isRentTypeAnd ? "사용 중" : "미사용"}
              </button>
              <p style={{ fontSize: '12px', color: '#666', marginTop: '6px' }}>* 복합거래 모드 활성 시 선택한 모든 유형이 포함된 매물만 검색됩니다.</p>
            </section>

            {/* 하단 고정 검색바 */}
            <div className="action-footer">
              <button className="btn" onClick={resetAll} style={{ flex: 1 }}>초기화</button>
              <button className="btn-primary" onClick={handleSearch} style={{ flex: 2 }}>검색 조건 적용</button>
            </div>

          </div>
        ) : (
          /* 기타 설정 탭 */
          <div key="tab-etc" className="tab-panel">
            <section>
              <div className="label">출력 설정</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '4px' }}>
                <span style={{ fontSize: '12px' }}>페이지당 매물:</span>
                <select value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }} style={{ height: '30px', flex: 1 }}>
                  {[10, 20, 50, 100, 200, 500, 1000].map(n => <option key={n} value={n}>{n}개씩</option>)}
                </select>
              </div>
            </section>
            <section style={{ marginTop: '20px' }}>
              <div className="label">거래 모드 토글</div>
              <button className="btn" style={{ width: '100%', height: '34px' }} onClick={() => setRentTypeAnd(v => !v)}>
                복합거래(AND) 모드: {isRentTypeAnd ? "사용 중" : "미사용"}
              </button>
              <p style={{ fontSize: '12px', color: '#666', marginTop: '6px' }}>* 복합거래 모드 활성 시 선택한 모든 유형이 포함된 매물만 검색됩니다.</p>
            </section>
          </div>
        )}
      </div>
    </aside>
  );
};

// ============================================================
// 🔄 SearchLoadingSpinner: 통합검색 실행 중 화면에 표시되는 로딩 오버레이
// loading 상태가 true 일 때 리스트 영역 위에 반투명 오버레이 + 스피너 표시
// ============================================================
const SearchLoadingSpinner = ({ visible }) => {
  if (!visible) return null; // loading=false 면 렌더 안 함
  return (
    <div
      style={{
        position: "absolute",          // 부모(리스트 컨테이너) 기준으로 위치
        inset: 0,                      // top/right/bottom/left 모두 0 → 완전 덮음
        zIndex: 50,                    // 리스트보다 위에 표시
        backgroundColor: "rgba(255,255,255,0.72)", // 반투명 흰색 배경
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        pointerEvents: "all",          // 스피너 표시 중 클릭 차단
      }}
    >
      {/* CSS 애니메이션 스피너 (외부 라이브러리 불필요) */}
      <style>{`
        @keyframes spin-ring {
          to { transform: rotate(360deg); }
        }
        .search-spinner-ring {
          width: 44px; height: 44px;
          border: 5px solid #e2e8f0;
          border-top-color: #2b6cb0;
          border-radius: 50%;
          animation: spin-ring 0.75s linear infinite;
        }
      `}</style>
      <div className="search-spinner-ring" />
      <span style={{ fontSize: "13px", color: "#4a5568", fontWeight: 600 }}>
        검색 중…
      </span>
    </div>
  );
};



  // [FILTER_MEMO_V1] filters 외 참조 없음. 함수 재생성을 막아 filteredItems useMemo 를 실제로 작동시킨다.
  const passExtraFilters = useCallback((p) => {
    // 1. 검색어(q)가 있다면 프론트엔드의 모든 추가 필터링을 건너뜁니다.
    if (filters.q && String(filters.q).trim() !== "") return true;

    // 2. 검색어가 없을 때만 아래의 세부 필터들을 적용합니다.
    if (filters.use_yn_n && p.use_yn !== "n") return false;
    if (filters.contract_yn_y && p.contract_yn !== "y") return false;
    if (filters.mortgage_yn_n && p.mortgage_yn !== "n") return false;

    if (filters.estate_type?.length>0 && !filters.estate_type.includes(p.estate_type)) return false;
    if (filters.bld_type?.length>0 && !filters.bld_type.includes(p.bld_type)) return false;
    // [DEAL_FILTER_FIX_V1] 거래유형 2차 필터
    //  - 서버 응답의 p.rent_type 은 '대표값 1개'(분양>월세>전세>단기>경매>매매 순)라
    //    「월세+매매」 매물은 'rent' 로만 와서 매매 선택 시 탈락했다.
    //  - 매물이 가진 거래유형을 전부 모아(has) 비교한다.
    //    출처: 서버가 주는 배열(rent_types) + 대표값(rent_type) + 원본 y/n 칸 6개 — 있는 것만 사용
    //  - 「복합(AND)」 켜짐 = 고른 유형을 모두 가진 매물 / 꺼짐 = 하나라도 가진 매물
    //    (서버 properties.js 의 rent_type_and 규칙과 같음)
    if (filters.rent_types?.length > 0) {
      const RT_COL = {
        sale: "rent_type_5sale", rent: "rent_type_2month", charter: "rent_type_1year",
        short: "rent_type_3short", deal: "rent_type_4deal", auction: "rent_type_6auction",
      };
      const has = new Set(Array.isArray(p.rent_types) ? p.rent_types : []);
      if (p.rent_type) has.add(p.rent_type);
      for (const k in RT_COL) if (p[RT_COL[k]] === "y") has.add(k);
      const andMode = isRentTypeAnd; // [SIX_AND_FIX_V1] 복합(AND) 버튼 상태 (useState 선언 923줄 부근, buildParams 도 같은 값 사용)
      const ok = andMode
        ? filters.rent_types.every((k) => has.has(k))
        : filters.rent_types.some((k) => has.has(k));
      if (!ok) return false;
    }
    if (filters.bld_structure?.length>0 && !filters.bld_structure.includes(p.bld_structure)) return false;
    if (filters.grade_condition && p.grade_condition !== filters.grade_condition) return false;

    // 준공년도 [minYear, maxYear]
    if (filters.completion_year?.length===2 && p.completion_year) {
      const y = Number(p.completion_year);
      if (Number.isFinite(y)) {
        const [minY, maxY] = filters.completion_year;
        if (!(y >= minY && y <= maxY)) return false;
      }
    }
    return true;
  }, [filters, isRentTypeAnd]); // [SIX_AND_FIX_V1] 복합(AND) 변경 시 재계산

  // [FILTER_MEMO_V1] num 은 모듈 최상단에 있으므로 deps 불필요. filters 만 재료로 둔다.
  const feeOK = useCallback((p) => {
    if (!filters.parking_paid) return true; // 체크 안 했으면 통과
    const fee = num(p.parking_fee ?? p.parking_price);
    return fee >= 0.1;
  }, [filters]);

    const loadUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/users', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.data.success) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error('사용자 목록 로드 실패:', error);
    }
  };

  // === 지도, 리스트 클릭 시 하이라이트 및 이동 확인용 로직 ===
  useEffect(() => {
    if (highlightedId) {
      console.log("🔵 현재 선택된 매물 ID (Highlight):", highlightedId);
      // 여기에 추가적인 이동 보정 로직이 필요하다면 작성
    }
  }, [highlightedId]);
  // 리스트용, 지도용 각각 필터 적용
  const filteredItems = useMemo(() => {
    let base = (items || []).filter(feeOK).filter(passExtraFilters);

    // // ★ AddressSearch 강제 주입 (페이지/필터/날짜 무시) //★AddressSearch관련
    // if (forcedItem?.estate_no) {
    //   const id = Number(forcedItem.estate_no);
    //   const exists = base.some(p => Number(getId(p)) === id);
    //   if (!exists) {
    //     base = [forcedItem, ...base];
    //   }
    // }

    // ★ 하이라이트는 무조건 최상단
    if (highlightedId != null) {
      const hid = Number(highlightedId);
      const picked = base.find(p => Number(getId(p)) === hid);
      if (picked) {
        return [picked, ...base.filter(p => Number(getId(p)) !== hid)];
      }
    }

    return base;
  // }, [items, forcedItem, highlightedId, feeOK, passExtraFilters]); //★AddressSearch관련
  }, [items, highlightedId, feeOK, passExtraFilters]);

  useEffect(() => {
    console.log("🔵 filteredItems[0]:", filteredItems[0]?.estate_no);
  }, [filteredItems]);

  // 페이지당 출력리스트 수 설정
  useEffect(() => {
  fetch("/api/app-config")
    .then(res => res.json())
    .then(data => {
      if (data.ok && data.page_size) {
        setPageSize(data.page_size);
      }
    });
}, []);

  // ★ tab 변경 시 사용자 목록 로드
  useEffect(() => {
    if (tab === 'manage' && userData?.grade === 'admin') {
      loadUsers();
    }
  }, [tab, userData?.grade]);

  // === 지도, 리스트, AddressSearch 에서 클릭시 상단으로 이동 로직 2026.01.02 ===

  const propertiesForMap = ((mapItems.length>0?mapItems:items) || []).filter(feeOK).filter(passExtraFilters);

  // [MAP_POPUP_V1] 팝업 지도창(BroadcastChannel 'momo-map')과 연동
  //   · 현재 마커(propertiesForMap)/중심/하이라이트를 팝업으로 보냄
  //   · 팝업에서 마커를 클릭하면 estate_no 를 받아 기존 selectEstate() 실행
  const mapPopupChRef = useRef(null);
  useEffect(() => {
    let ch;
    try { ch = new BroadcastChannel("momo-map"); } catch (e) { ch = null; }
    mapPopupChRef.current = ch;
    if (!ch) return;
    const sendSync = () => {
      try {
        ch.postMessage({ type: "sync", properties: propertiesForMap, center: mapCenter, highlightedId });
      } catch (e) {}
    };
    ch.onmessage = (ev) => {
      const m = ev.data || {};
      if (m.type === "ready") { sendSync(); return; }
      if (m.type === "markerClick" && m.estate_no != null) {
        const src = (mapItems.length > 0 ? mapItems : items) || [];
        const est = src.find(x => Number(x.estate_no) === Number(m.estate_no));
        if (est) selectEstate(est);
      }
    };
    sendSync();  // 열려있는 팝업에 즉시 최신 상태 전송
    return () => { try { ch.close(); } catch (e) {} };
  }, [propertiesForMap, mapCenter, highlightedId, items, mapItems, selectEstate]);

  const openMapPopup = useCallback(() => {
    window.open("/map-popup", "momoMapPopup", "width=1280,height=900");
  }, []);

  // 🔥 기존에 return 안에 있던 “메인 화면 JSX 전부”
  const homeContent = (
    <>
        {/* 1. 최상위 컨테이너: 헤더를 제외한 높이 고정 및 스크롤 차단 */}
        <div style={{ 
          width: "100%", 
          maxwidth: "100vw",
          margin: "0 auto", 
          padding: "0 20px",
          height: "calc(100vh - 98px)", // 헤더 2행(로고60px + 네비38px) 높이 제외
          display: "flex", 
          flexDirection: "column", 
          overflow: "hidden",
          boxSizing: "border-box" 
        }}>

          {/* 1. 조건관리(기존 관리페이지) 탭 */}
          {tab === "manage" && (
            <div className="manage-scroll custom-scrollbar" style={{ 
              flex: 1, 
              overflowY: "auto", 
              padding: "20px 5px",
              backgroundColor: "#f8fafc" // 아주 연한 회색 배경으로 세련미 추가
            }}>
              <div style={{ 
                display: "grid", 
                gridTemplateColumns: "320px 1fr", // 고정 사이드바 + 유연한 메인 영역
                gap: "24px", 
                maxWidth: "1300px",
                margin: "0 auto" 
              }}>
                
                {/* --- 왼쪽 사이드 카드: 기본 설정 --- */}
                <aside style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  
                  {/* 지역 설정 카드 */}
                  <div style={modernCardStyle}>
                    {/* [CARD_LABEL_V1] 아래 '물건접수 지역 설정'과 구분하기 위해
                        이 카드는 '이 브라우저에서만' 쓰는 임시 위치임을 명시한다. */}
                    <h3 style={modernTitleStyle}>📍 지도 위치 (이 기기 전용)</h3>
                    <p style={modernSubTitleStyle}>
                      이 브라우저에서만 적용되는 지도 시작 위치입니다.
                      비워두면 아래 <b>물건접수 지역 설정</b>의 기본 구를 따릅니다.
                    </p>
                    <div style={{ marginTop: "15px" }}>
                      <RegionSelector
                        value={mapCenter}
                        onChange={(center) => {
                          setMapCenter(center);
                          localStorage.setItem("homeCenter.pending", JSON.stringify(center));
                        }}
                      />
                    </div>
                    <div style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
                      <button style={primaryButtonStyle} onClick={() => {
                        const s = localStorage.getItem("homeCenter.pending");
                        if (s) {
                          localStorage.setItem("homeCenter", s);
                          setMapCenter(JSON.parse(s));
                          alert("기본 지역 저장 완료");
                        }
                      }}>저장</button>
                      <button style={secondaryButtonStyle} onClick={() => {
                        localStorage.removeItem("homeCenter");
                        setMapCenter(DEFAULT_CENTER);
                        alert("초기화 완료");
                      }}>초기화</button>
                    </div>
                  </div>

                  {/* 데이터 관리 카드 */}
                  <div style={modernCardStyle}>
                    <h3 style={modernTitleStyle}>⚙️ 데이터 엔진</h3>
                    <button style={{ ...secondaryButtonStyle, width: "100%", marginTop: "10px" }} onClick={async () => {
                      setManageMsg("동기화 중...");
                      try {
                        const res = await fetch('/api/regions/refresh', { method: 'POST' });
                        const result = await res.json();
                        setManageMsg(result.message || '동기화 성공');
                      } catch (e) { setManageMsg(`오류 발생`); }
                    }}>지역 코드 최신화</button>
                    {manageMsg && <p style={{ fontSize: '11px', color: '#64748b', marginTop: '8px', textAlign: 'center' }}>{manageMsg}</p>}
                  </div>

{/* ★ 등급설정 (관리자만) */}
                  {userData?.grade === 'admin' && (
                    <div style={modernCardStyle}>
                      <h3 style={modernTitleStyle}>🔐 등급설정</h3>
                      
                      {/* 사용자 선택 */}
                      <div style={{ marginTop: "12px" }}>
                        <label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '5px' }}>사용자 선택</label>
                        <select 
                          id="userSelect"
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '4px',
                            fontSize: '13px',
                            fontFamily: 'Arial, sans-serif'
                          }}
                          onChange={(e) => {
                            const userId = e.target.value;
                            setSelectedUserId(userId);
                            
                            // ★ 선택된 사용자의 등급 자동 설정
                            const selectedUser = users.find(u => u.user_id === userId);
                            if (selectedUser) {
                              setSelectedGrade(selectedUser.grade);
                            }
                          }}
                        >
                          <option value="">사용자를 선택하세요</option>
                          {users && users.map(u => (
                            <option key={u.user_id} value={u.user_id}>
                              {u.name} ({u.email})
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* 등급 선택 */}
                      <div style={{ marginTop: "12px" }}>
                        <label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '5px' }}>등급 선택</label>
                        <select 
                          id="gradeSelect"
                          value={selectedGrade}  // ← 이 줄 추가!
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '4px',
                            fontSize: '13px',
                            fontFamily: 'Arial, sans-serif'
                          }}
                          onChange={(e) => setSelectedGrade(e.target.value)}
                        >
                          <option value="">등급을 선택하세요</option>
                          <option value="guest">👤 Guest (손님)</option>
                          <option value="basic">📝 Basic (기본)</option>
                          <option value="premium">⭐ Premium (직원)</option>
                          <option value="admin">🔐 Admin (관리자)</option>
                        </select>
                      </div>

                      {/* 저장 버튼 */}
                      <div style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
                        <button 
                          style={primaryButtonStyle}
                          onClick={async () => {
                            if (!selectedUserId || !selectedGrade) {
                              setGradeMsg('사용자와 등급을 모두 선택하세요');
                              return;
                            }
                            setGradeMsg('저장 중...');
                            try {
                              const token = localStorage.getItem('token');
                              const response = await axios.put(`/api/users/${selectedUserId}/grade`, {
                                grade: selectedGrade
                              }, {
                                headers: { 'Authorization': `Bearer ${token}` }
                              });
                              if (response.data.success) {
                                setGradeMsg('등급이 업데이트되었습니다! ✅');
                                // 사용자 목록 새로고침
                                setTimeout(() => loadUsers(), 500);
                              }
                            } catch (error) {
                              setGradeMsg('저장 실패: ' + error.response?.data?.message);
                            }
                          }}
                        >
                          💾 저장
                        </button>
                      </div>

                      {/* 메시지 */}
                      {gradeMsg && (
                        <p style={{ fontSize: '11px', color: '#64748b', marginTop: '8px', textAlign: 'center' }}>
                          {gradeMsg}
                        </p>
                      )}
                    </div>
                  )}


                  {/* ★ SMS 발송관리 (관리자만) */}
                  {userData?.grade === 'admin' && (
                    <SmsRuleManager
                      cardStyle={modernCardStyle}
                      titleStyle={modernTitleStyle}
                      subTitleStyle={modernSubTitleStyle}
                    />
                  )}
                </aside>

                {/* --- 오른쪽 메인 카드 영역 --- */}
                <main style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  
                  {/* 조건 노출 관리 (체크박스 영역) */}
                  <div style={modernCardStyle}>
                    <h3 style={modernTitleStyle}>🔍 검색 조건 표시 설정</h3>
                    <p style={modernSubTitleStyle}>사용자 화면에 노출할 필터를 선택하세요.</p>
                    <div style={{ 
                      display: "grid", 
                      gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", 
                      gap: "12px", 
                      marginTop: "20px",
                      padding: "15px",
                      backgroundColor: "#f1f5f9",
                      borderRadius: "8px"
                    }}>
                      {Object.keys(visibleSections).map((key) => (
                        <label key={key} style={modernCheckboxLabelStyle}>
                          <input
                            type="checkbox"
                            style={modernCheckboxStyle}
                            checked={visibleSections[key]}
                            onChange={(e) => setVisibleSections({ ...visibleSections, [key]: e.target.checked })}
                          />
                          <span style={{ fontSize: "13px", fontWeight: "500", color: "#334155" }}>
                            {SECTION_LABELS[key] || key}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* 필터 세부 설정 및 사진 관리 (ConditionManage 내부는 해당 컴포넌트에서 수정 필요) */}
                  <div style={modernCardStyle}>
                    <h3 style={modernTitleStyle}>🖼️ 사진 및 미디어 설정</h3>
                    {/* [PHOTO_CARD_V2] 부제목 — 다른 카드와 형식 통일 */}
                    <p style={modernSubTitleStyle}>사진 저장 위치, 공급자 정보, 워터마크를 설정합니다.</p>
                    <ConditionManage
                      onSearch={handleSearch}
                      onReset={resetAll}
                    />
                    
                    {/* [PHOTO_CARD_V2] '사진 표시 기준' — 이 브라우저에서 사진을 어디서 불러올지.
                        ConditionManage 안의 '사진 저장 위치'(서버 전체 설정)와는 다른 항목이므로
                        이름을 구분해 혼동을 없앤다. 값은 localStorage 에만 저장된다. */}
                    <div style={{
                      padding: "14px", background: "#f8fafc",
                      border: "1px solid #e2e8f0", borderRadius: "8px",
                    }}>
                      <div style={{ fontSize: "14px", fontWeight: 700, color: "#1e293b", marginBottom: "3px" }}>사진 표시 기준</div>
                      <div style={{ fontSize: "11px", color: "#94a3b8", marginBottom: "10px" }}>
                        지금 이 브라우저에서 사진을 불러올 곳입니다. 다른 기기에는 영향을 주지 않습니다.
                      </div>
                      <div style={{ display: "flex", gap: "10px" }}>
                        {["server", "gdrive"].map(src => (
                          <label key={src} style={src === photoSource ? modernRadioActiveStyle : modernRadioStyle}>
                            <input
                              type="radio"
                              name="photoSrc"
                              value={src}
                              style={{ display: "none" }}
                              checked={photoSource === src}
                              onChange={() => setPhotoSource(src)}
                            />
                            {src === "server" ? "자체 서버" : "구글 드라이브"}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* [SLIDER_CFG_CARD_V1] 슬라이더 범위 설정 카드.
                      값은 서버 app_config 테이블(key='slider_config')에 저장되며,
                      필터 패널의 슬라이더가 같은 값을 읽어 동작한다. */}
                  {/* 직원 물건접수폼 기본지역 [REGION_CFG_CARD_V1] */}
                  <RegionConfigManager
                    cardStyle={modernCardStyle}
                    titleStyle={modernTitleStyle}
                    subTitleStyle={modernSubTitleStyle}
                  />
                  <SliderConfigManager
                    cardStyle={modernCardStyle}
                    titleStyle={modernTitleStyle}
                    subTitleStyle={modernSubTitleStyle}
                  />
                  
                  {/* [RT_CFG_CARD_V1] 실거래 조회 설정 카드 (관리자만).
                      단지 주변 중개사무소를 집계할 반경(m)을 지정한다.
                      값은 app_config(key='rt_agent_radius_m')에 저장되며,
                      단지분석 탭의 "주변 중개사무소 표시"가 같은 값을 읽는다.
                      백엔드 /api/real-trades/* 가 admin 전용이므로 화면도 맞춘다. */}
                  {userData?.grade === 'admin' && (
                    <RealTradeConfig
                      cardStyle={modernCardStyle}
                      titleStyle={modernTitleStyle}
                      subTitleStyle={modernSubTitleStyle}
                    />
                  )}

                  {/* [PERM_CARD_V1] 접근권한 관리 (관리자만).
                      rt_permissions 테이블의 등급 설정을 편집한다.
                      변경 즉시 requirePerm 미들웨어에 반영된다. */}
                  {userData?.grade === 'admin' && (
                    <PermissionManager
                      cardStyle={modernCardStyle}
                      titleStyle={modernTitleStyle}
                      subTitleStyle={modernSubTitleStyle}
                    />
                  )}
                  
                </main>

              </div>
            </div>
          )}

          {/* 2. 업무지원 탭 (신규 추가된 섹션) */}
          {tab === "support" && (
            <div className="support-container" style={{ padding: "10px 0 30px", flex: 1, overflowY: "auto", minHeight: 0 }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" }}>
                {[
                  {
                    title: "계약 전 확인 사항",
                    color: "#3b82f6",
                    links: [
                      { label: "양도세 계산(홈택스)", url: "https://hometax.go.kr/websquare/websquare.wq?w2xPath=/ui/pp/index.xml&tmIdx=0&tm2lIdx=&tm3lIdx=" },
                      { label: "취득세 계산(위택스)", url: "https://www.wetax.go.kr/tcp/loi/J030801M01.do" },
                      { label: "실거래가 정보(국토부)", url: "http://rt.molit.go.kr/" },
                      { label: "중개업소 검색(NSDI)", url: "https://www.vworld.kr/dtld/broker/dtld_list_s001.do" },
                    ]
                  },
                  {
                    title: "계약 시 확인 사항",
                    color: "#ef4444",
                    links: [
                      { label: "인터넷등기소(열람)", url: "http://www.iros.go.kr/" },
                      { label: "단독주택정보", url: "http://kras.seoul.go.kr/land_info/info/baseInfo/baseInfo.do?service=init&landcode=1162000000" },
                      { label: "다세대(지분) 확인", url: "http://land.seoul.go.kr/land/wskras/generalInfo.do" },
                      { label: "공시가격(주택)", url: "https://www.realtyprice.kr/notice/town/searchPastYear.htm" },
                      { label: "기준시가(오피스텔)", url: "https://hometax.go.kr/websquare/websquare.html?w2xPath=/ui/pp/index_pp.xml&tmIdx=47&tm2lIdx=4712090000&tm3lIdx=4712090300" },
                      { label: "KB 부동산시세", url: "https://kbland.kr/" },
                      { label: "부동산테크 시세", url: "https://www.rtech.or.kr/main/main.do" },
                      { label: "대형 오피스텔/상업용 공시가", url: "https://teht.hometax.go.kr/websquare/websquare.html?w2xPath=/ui/sf/a/a/UTESFAAM13.xml" },
                      { label: "시가표준액(서울-주택외)", url: "https://etax.seoul.go.kr/BldnStndAmtLstAction.view?gnb_id=0709&lnb_id=0709&gl_gubun=l" },
                      { label: "시가표준액(서울외-주택외)", url: "https://www.wetax.go.kr/tcp/loi/J030401M01.do" },
                      { label: "토지이음(이용규제)", url: "https://www.eum.go.kr/web/am/amMain.jsp" },
                      { label: "정부24(구 민원24)", url: "https://www.gov.kr/" }, // ★ 추가
                      { label: "세움터", url: "https://www.eais.go.kr/" },
                      { label: "건축물대장/진위확인", url: "https://www.gov.kr/main?a=AA020InfoCappViewApp&CappBizCD=15000000098&HighCtgCD=A02004002&Mcode=10205" },
                    ]
                  },
                  {
                    title: "경매 관련 서비스", // ★ 섹션 분리 및 보강
                    color: "#8b5cf6",
                    links: [
                      { label: "법원경매정보", url: "https://www.courtauction.go.kr/" },
                      { label: "지지옥션", url: "https://www.ggi.co.kr/" },
                      { label: "지지옥션 경락잔금 거래소", url: "https://www.ggi.co.kr/market/loan_main.asp" }, // ★ 추가
                      { label: "두인경매", url: "http://www.dooinauction.com/" },
                      { label: "레이옥션", url: "https://www.reyauction.com/" }, // ★ 추가
                      { label: "베프옥션", url: "https://www.befauction.com/" }, // ★ 추가
                      { label: "스피드옥션", url: "https://www.speedauction.co.kr/" }, // ★ 추가
                    ]
                  },
                  {
                    title: "계약 및 잔금 후 처리",
                    color: "#10b981",
                    links: [
                      { label: "실거래가 신고(RTMS)", url: "https://rtms.molit.go.kr/" },
                      { label: "전기요금 정산", url: "http://cyber.kepco.co.kr/" },
                      { label: "수도요금 정산", url: "http://i121.seoul.go.kr/cs/cyber/front/hmvsettle/NR_hmvsettleCalc.do?_m=m3_2" },
                      { label: "가스요금 정산(서울가스)", url: "https://www.seoulgas.co.kr/" },
                      { label: "현금영수증 발행", url: "https://www.hometax.go.kr/" },
                    ]
                  },
                  {
                    title: "기타 참고 사이트",
                    color: "#6b7280",
                    links: [
                      { label: "네이버", url: "https://naver.com/" },
                      { label: "네이버 부동산", url: "https://land.naver.com/" },
                      { label: "다음 지도(카카오맵)", url: "http://map.daum.net/" }, // ★ 추가
                      { label: "공실클럽", url: "http://www.gongsilclub.com/v3/main.asp" },
                      { label: "디스코(실거래가 조회)", url: "https://www.disco.re/" }, // ★ 추가
                      { label: "한국공인중개사협회", url: "http://www.kar.or.kr/" }, // ★ 추가
                      { label: "한국감정원(부동산원)", url: "http://www.kab.co.kr/" },
                      { label: "청약홈", url: "https://www.applyhome.co.kr/" },
                    ]
                  }
                ].map((section, idx) => (
                  <div key={idx} style={{ background: "#fff", borderRadius: "10px", border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)" }}>
                    <div style={{ background: section.color, color: "#fff", padding: "10px 15px", fontSize: "14px", fontWeight: "bold" }}>
                      {section.title}
                    </div>
                    <div style={{ padding: "10px" }}>
                      {section.links.map((link, lidx) => (
                        <a 
                          key={lidx} 
                          href={link.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ display: "block", padding: "8px 12px", color: "#4a5568", textDecoration: "none", fontSize: "13px", borderRadius: "6px", transition: "background 0.2s" }}
                          onMouseOver={(e) => e.target.style.background = "#f7fafc"}
                          onMouseOut={(e) => e.target.style.background = "transparent"}
                        >
                          • {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 3. 검색(지도/리스트) 탭 (기본값) */}
          {tab === "search" && (
            <div className="search-page" style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, width: "100%" }}>

                      {/* 지도 출력 */}
                      <div 
                        className="map-top" 
                        style={{ 
                          flexShrink: 0, 
                          height: isMobile ? (mapExpanded ? "45vh" : "16vh") : "calc((100vh - 320px) / 2)",
                          // PC 지도 높이를 기존 계산값의 절반으로 줄임
                          // 모바일이면 기존 토글 로직(16vh/45vh) 그대로 사용
                          // PC면 화면 전체 높이에서 헤더+검색영역 정도(320px)를 뺀 큰 지도를 그대로 보여줌
                          // PC의 원래 지도 높이가 어느 정도였는지 모르니, 일단 화면 보고 320px 값은 조정 가능
                          
                          // 기존 32vh의 절반인 16vh로 변경 (모바일 화면 기준).
                          // 확대 버튼을 누르면 여전히 70vh로 커짐.
                          // mapExpanded가 true면 지도를 화면의 70%까지 키우고,
                          // false(기본값)면 32%만 차지해서 아래 리스트(PropertyList)가 
                          // 화면 대부분을 차지하도록 함.
                          transition: "height 0.25s ease",
                          // 높이가 갑자기 바뀌지 않고 0.25초 동안 부드럽게 늘어나거나 줄어들게 함.
                          position: "relative" 
                          // 아래 추가할 확장/축소 버튼을 지도 위에 절대위치로 띄우기 위한 기준점
                        }}
                      >
                        {/* 지도 확장/축소 토글 버튼 */}
                        <button
                          onClick={() => setMapExpanded(!mapExpanded)}
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            zIndex: 50, 
                            // 카카오맵의 마커, 컨트롤 버튼들보다 위에 떠 있도록 z-index를 높게 줌
                            padding: "6px 12px",
                            backgroundColor: "#1f2937",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                          }}
                        >
                          {mapExpanded ? "🗂️ 리스트 위주 보기" : "🗺️ 지도 확장"}
                        </button>
                        {mapsReady && (
                          <KakaoMap
                            key={`${mapItems.length > 0 ? 'map' : 'page'}-${propertiesForMap.length}`} 
                            properties={propertiesForMap}
                            center={mapCenter}
                            highlightedId={highlightedId}
                            onExpandMap={() => setMapExpanded(prev => !prev)}
                            onOpenPopup={openMapPopup}
                            // true 고정이 아니라 현재 상태의 반대값으로 토글
                            mapExpanded={mapExpanded}
                            // 버튼 텍스트를 "확대"/"축소"로 바꾸기 위해 현재 상태도 같이 전달

                            // 지도 안의 "확대" 버튼을 눌렀을 때 실행됨.
                            // mapExpanded를 true로 바꾸면 위쪽 map-top div 높이가 70vh로 커짐.
                            onMarkerClick={(id, p) => {
                              console.log("📍 Marker Clicked Data:", p);

                            // =========== 제미나이 제안 (수정) 2026.01.18

                              // 1. KakaoMap에서 보낸 데이터가 그룹(type: "group")인 경우 즉시 처리
                              if (p?.type === "group" && Array.isArray(p.items)) {
                                console.log("✅ Group detected, count:", p.items.length);
                                setHoListItems(p.items);
                                setHoListOpen(true);

                            // [복원] 그룹의 대표 매물을 리스트 최상단으로 올리고 하이라이트
                                if (p.items.length > 0) {
                                  selectEstate(p.items[0]);
                                }
                                return;
                              }

                              // 2. 주소 키(getAddressKey)를 생성하여 리스트 내 동일 건물 매물 수집
                              const targetKey = getAddressKey(p);
                              console.log("🔑 Target Address Key:", targetKey);
                              if (targetKey) {
                            // filteredItems에서 같은 주소를 가진 매물 필터링
                                const samePlace = filteredItems.filter(it => {
                                  const itKey = getAddressKey(it);
                                  return itKey === targetKey;
                                });

                                console.log("🏠 Found Same Place Items:", samePlace.length);

                                if (samePlace.length > 1) {
                                  setHoListItems(samePlace);
                                  setHoListOpen(true);
                                  console.log("🚀 setHoListOpen(true) executed!");
                            // [복원] 클릭한 해당 매물을 리스트 최상단으로 이동
                                  selectEstate(p);
                                } else {
                                  // 매물이 하나뿐이면 리스트 상단으로 이동 및 하이라이트
                                  selectEstate(p);
                                }
                              }

                            // =========== 제미나이 제안 (수정) 2026.01.18

                            }}
                          />
                        )}
                        
                        {/* 지도 위 오버레이: 영역 자체는 클릭 통과 */}
                        <div className="map-overlay" style={{ pointerEvents: "none", position: "absolute", top: 15, left: 15, zIndex: 100 }}>

                          {/* 좌측 상단 컨트롤 묶음: 일렬로 밑으로 순차적으로 출력 */}
                          <div
                            className="map-controls-vertical"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              gap: 10, // 각 요소 사이의 일정한 간격
                              pointerEvents: "none",
                            }}
                          >

                            {/* 2. 패널열기 버튼: 실제 정의된 panelOpen 상태와 setPanelOpen 함수 사용 */}
                            <div style={{ pointerEvents: "auto" }}>
                              <button
                                className="map-chip-btn list-btn"
                                data-panel-toggle="1"
                                onClick={() => setPanelOpen(!panelOpen)}
                                style={{ boxShadow: "0 2px 4px rgba(0,0,0,0.2)", whiteSpace: "nowrap" }}
                              >
                                📋 {panelOpen ? "패널닫기" : "패널열기"}
                                {activeFilters > 0 && (
                                  <span
                                    className="chip-badge"
                                    onClick={(e) => {
                                      // 버튼 토글 클릭과 분리
                                      e.stopPropagation();
                                      if (!activeFilterLabels.length) {
                                        alert("적용된 필터가 없습니다.");
                                        return;
                                      }
                                      alert(
                                        activeFilterLabels
                                          .map((label, idx) => `${idx + 1}. ${label}`)
                                          .join("\n")
                                      );
                                    }}
                                  >
                                    {activeFilters}
                                  </span>
                                )}
                              </button>
                            </div>

                            {/* 3. 평 변환 (단위변환) - 겹침 방지를 위해 margin 제거하고 자연스럽게 배치 */}
                            <div
                              className="unit-converter"
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 6,
                                pointerEvents: "auto",
                                backgroundColor: "rgba(255,255,255,0.9)",
                                padding: "4px 8px",
                                borderRadius: "8px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                marginTop: 5 // 버튼들과의 최소 간격
                              }}
                            >
                              <input
                                value={sqm}
                                onChange={onSqmChange}
                                inputMode="decimal"
                                placeholder="㎡"
                                style={{ width: 40, textAlign: "right", padding: "2px 6px" }}
                              />
                              <span>↔</span>
                              <input
                                value={pyeong}
                                onChange={onPyeongChange}
                                inputMode="decimal"
                                placeholder="평"
                                style={{ width: 40, textAlign: "right", padding: "2px 6px" }}
                              />
                            </div>
                          </div>


                          {/* 검색결과 마커 모두 보기 */}
                          <div style={{ position: 'absolute', top: '8px', right: '8px', zIndex: 30, pointerEvents: 'auto' }}>
                            <button onClick={loadAllForMap} className="chip-button">
                              🗺️ 현 검색결과 전체보기
                            </button>
                          </div>

                        </div>
                      </div>

                      {/* 검색결과 수 출력 줄 */}
                        <div
                          className="result-row"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                            flexShrink: 0,
                            background: "#fff",
                            zIndex: 11,
                            padding: "8px 0"
                          }}
                        >

                          {/* 1행: pager */}
                          <div className="pager">
                            <span>{total}건중/{filteredItems?.length ?? 0}씩 • {page}/{totalPages ?? 1} </span>
                            <div style={{ display: "inline-flex", gap: 8 }}>
                              <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}> 이전 </button>
                              <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}> 다음 </button>
                            </div>
                          </div>

                          {/* 2행: 소재지 검색 / 신규등록 //★AddressSearch관련
                          <div
                            className="search-sticky"
                            style={{
                              position: "sticky",
                              top: 0,                // 헤더가 있으면 그 높이만큼 조정
                              zIndex: "auto",
                              background: "#fff",
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              padding: "8px 0",
                            }}
                          >
                            <AddressSearch
                              // key={searchResetKey}
                              onPick={(it) => {
                                if (!it?.estate_no) return;

                                const no = Number(it.estate_no);
                                setHighlightedId(no);

                                fetch(`/api/properties/by-estate-no?estate_no=${no}`)
                                  .then(r => r.json())
                                  .then(j => {
                                    const item = j?.items?.[0];
                                    if (!item) {
                                      console.warn("❌ forcedItem fetch empty", no);
                                      return;
                                    }
                                    console.log("🟢 setForcedItem", item.estate_no);
                                    setForcedItem(item);   // ★ 여기 핵심
                                  });
                              }}

                              onNewAddress={(addr) => {
                                if (!addr) return;
                                const roadAddress =
                                  typeof addr === "string"
                                    ? addr
                                    : addr.roadAddress || addr.jibunAddress || "";
                                const jibunAddress =
                                  typeof addr === "string"
                                    ? addr
                                    : addr.jibunAddress || addr.roadAddress || "";

                                if (!roadAddress && !jibunAddress) return;

                                const newEstate = {
                                  estate_no: null,
                                  estate_id: null,
                                  branch_id: null,
                                  roadAddress,
                                  jibunAddress,
                                  detailAddress: "",
                                };
                                openEditorNew(newEstate);
                              }}
                            />
                          </div> */}

                          {/* 2행: 통합 키워드 검색 및 6개월 스위치 */}
                          <div className="search-sticky" style={{
                            position: "sticky", 
                            top: 0, 
                            zIndex: 10, 
                            background: "#fff",
                            display: "flex", 
                            flexWrap: "nowrap",   // 추가: 자식 요소들이 줄바꿈되지 않고 한 줄에서 각자 비율대로 줄어들도록 강제
                            alignItems: "center", 
                            padding: "8px 0",
                            gap: "6px",            // 추가: 검색박스/토글/신규등록 버튼 사이 최소 간격 확보
                            borderBottom: "1px solid #edf2f7",
                            width: "100%"                 // 전체 너비 사용
                          }}>
                            
                          {/* 1. 검색창 및 검색 버튼 영역 */}
                            <div 
                              className="integrated-search-box"
                              style={{ display: "flex", alignItems: "center", gap: "6px", flex: "0 1 35%", minWidth: 0 }}
                              // display:"flex"를 줘야 내부 검색창의 flex:"0 1 50%" 속성이 실제로 동작함.
                              // 이 div 자체에도 flex:"0 1 50%"를 줘서, 부모(search-sticky) 안에서
                              // 검색창 전체 영역이 페이지네이션(pager)과 비슷한 비율로 줄어들도록 함.
                            >
                              {/* 검색 대상 선택 드롭다운: 화면에서 숨기고 항상 "전체" 검색으로 고정
                                  나중에 다시 보이고 싶으면 style의 display:"none"만 지우면 됨 */}
                              <select
                                value={searchCol}
                                onChange={(e) => setSearchCol(e.target.value)}
                                style={{ display: "none" }}
                              >
                                <option value="all">전체</option>
                                <option value="address">주소/건물명</option>
                                <option value="memo">메모</option>
                                <option value="owners">임대인</option>
                                <option value="tenants">임차인</option>
                              </select>

                              <BlurCommitInput 
                                type="text" 
                                placeholder="주소, 건물명, 메모, 임대인, 임차인 검색" 
                                value={filters.q ?? ""} 
                                onChange={(e) => {
                                  setSearchInputVal(e.target.value);
                                }}
                                onCommit={(val) => {
                                  const msg = getSearchValidationMsg(val);
                                  if (msg) {
                                    alert(msg);
                                    return;
                                  }
                                  setPage(1); 
                                  setFilters(f => ({ ...f, q: val })); 
                                }}
                                style={{
                                  flex: 1,   // "0 1 50%" → 1로 변경 (부모 div가 이미 50% 크기로 줄었음)
                                  minWidth: 0,    // 추가: 위와 같은 이유
                                  padding: "8px 12px", fontSize: "13px",
                                  borderRadius: "4px", border: "1px solid #ccc",
                                  boxSizing: "border-box"
                                }}
                              />
                              <button
                                type="button"
                                onClick={() => {
                                  const currentVal = searchInputVal;
                                  const msg = getSearchValidationMsg(currentVal);
                                  if (msg) {
                                    alert(msg);
                                    return;
                                  }
                                  setPage(1);
                                  setFilters(f => ({ ...f, q: currentVal }));
                                }}
                                style={{
                                  flexShrink: 0, padding: "6px 10px", fontSize: "12px",  // 버튼 패딩 살짝 축소
                                  borderRadius: "4px", border: "1px solid #2b6cb0",
                                  background: "#2b6cb0", color: "#fff", cursor: "pointer", whiteSpace: "nowrap"
                                }}
                              >
                                검색
                              </button>
                            </div>

                            {/* 2. 6개월 스위치 영역 */}
                            <div 
                              style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", userSelect: "none", flexShrink: 0 }}
                              onClick={() => {
                                // [SIX_MONTH_AUTO_V1] 스위치만 바꾸면 목록이 안 바뀌던 문제 → 검색어가 있으면 filters 도 갱신해 즉시 재검색
                                //   _sixToggle 은 재조회 계기용 표시값 (서버는 모르는 값이라 무시됨)
                                const __six = !isIntegratedSixMonth;
                                setIsIntegratedSixMonth(__six);
                                // [SIX_AND_FIX_V1] 검색어가 없을 때도 스위치가 작동하도록 — 패널 수정일 범위를 직접 바꾼다
                                //   OFF → 시작일 비움 + all_dates=y (패널 「시작일 초기화」 버튼과 같은 방식 = 전체 기간)
                                //   ON  → 「6개월 전 ~ 오늘」로 복원 (defaultUpdateDateRange = 처음 화면 기본값과 같은 함수)
                                //   검색어가 있을 때는 buildParams 가 날짜를 지우고 six_month=y/n 을 보내므로 기존 동작 그대로
                                //   _sixToggle 은 filters 를 바꿔 재조회를 일으키는 표시값 (서버는 무시)
                                setFilters(f => __six
                                  ? { ...f, ...defaultUpdateDateRange(), all_dates: "", _sixToggle: __six }
                                  : { ...f, update_date_from: "", all_dates: "y", _sixToggle: __six });
                                setPage(1); 
                              }}
                            >
                              <span style={{ fontSize: "11px", fontWeight: "700", color: "#4a5568", whiteSpace: "nowrap" }}>
                                6개월 이내
                              </span>
                              <div style={{
                                width: "50px", height: "26px",
                                backgroundColor: isIntegratedSixMonth ? "#2b6cb0" : "#9e9e9e",
                                borderRadius: "20px", position: "relative",
                                display: "flex", alignItems: "center", transition: "all 0.3s ease"
                              }}>
                                <span style={{
                                  fontSize: "10px", fontWeight: "bold", color: "#fff", width: "100%",
                                  textAlign: isIntegratedSixMonth ? "left" : "right",
                                  padding: isIntegratedSixMonth ? "0 0 0 6px" : "0 6px 0 0"
                                }}>
                                  {isIntegratedSixMonth ? "ON" : "OFF"}
                                </span>
                                <div style={{
                                  width: "20px", height: "20px", backgroundColor: "#fff",
                                  borderRadius: "50%", position: "absolute",
                                  left: isIntegratedSixMonth ? "27px" : "3px",
                                  transition: "all 0.3s ease"
                                }} />
                              </div>
                            </div>

                            {/* 3. 신규등록 버튼 — 🔒 premium/admin 만 */}
                            {(userData?.grade === "admin" || userData?.grade === "premium") && (
                            <button
                              type="button"
                              onClick={handleNewRegister}
                              style={{
                                flexShrink: 0, padding: "6px 14px", fontSize: "12px",
                                borderRadius: "4px", border: "1px solid #28a745",
                                background: "#28a745", color: "#fff", fontWeight: "bold",
                                cursor: "pointer", whiteSpace: "nowrap"
                              }}
                            >
                              신규등록
                            </button>
                            )}
                          </div>
                        </div>

                      {/* 리스트 출력 줄 */}
                      {/*
                        ★ position: "relative" 추가 이유:
                        SearchLoadingSpinner가 position:"absolute" + inset:0 으로
                        이 div 를 꽉 채우면서 덮어야 하므로, 부모인 이 div 에
                        position:relative 를 반드시 지정해야 합니다.
                      */}
                      <div className="list-bottom property-list custom-scrollbar" ref={listRef} style={{ 
                        flex: 1, 
                        overflowY: "scroll", // 'auto' 대신 'scroll'을 주어 공간 미리 확보
                        minHeight: 0,
                        borderTop: "1px solid #eee",
                        padding: "0 15px 20px 15px", // 우측 패딩을 주어 스크롤바와 내용 분리
                        position: "relative"   // ★ 스피너 절대위치의 기준점
                      }}>
                        {/* ★ 검색 중 로딩 스피너: loading=true 일 때 리스트 위에 오버레이 표시 */}
                        <SearchLoadingSpinner visible={loading} />
                        <PropertyList
                          properties={filteredItems}
                          checkedIds={checkedProps.map(x => x.estate_no)}
                          onToggleCheck={(p) => setCheckedProps(prev =>
                            prev.some(x => Number(x.estate_no) === Number(p.estate_no))
                              ? prev.filter(x => Number(x.estate_no) !== Number(p.estate_no))
                              : [...prev, p]
                          )}
                          loading={loading}
                          highlightedId={highlightedId}
                          addressGroups={addressGroups}
                          onSelect={(id) => {
                            if (id == null) return setHighlightedId(null);
                            setHighlightedId(Number(id));
                            const p = propertiesForMap.find(x => Number(x.estate_no) === Number(id));
                            if (p) selectEstate(p);
                          }}

                          displaySource={photoSource}
                          // 리스트의 상세보기 클릭 시 "view" 모드로 오픈
                          onEditEstate={(p, mode = "edit") => openEditor(mode, p.estate_no)}
                          onCopyEstate={(p) => openEditor("copy", p.estate_no)}
                          onContractEstate={(p) => openEditor("contract", p.estate_no)}
                          onRefresh={load} // ✅ App.js의 load 함수를 직접 연결합니다.
                        />
                      </div>
                      {/* 우측 고정 오버레이 패널 */}
                      {/* [PANEL_DIRECT_CALL_V1] 꺾쇠 대신 함수 직접 호출 — 아래 주석 참고 */}
                      {/* OverlayPanel 은 App 안에 정의돼 있어 매 렌더 재생성된다.
                          <OverlayPanel/> 로 쓰면 React 가 DOM 을 폐기해
                          필터 패널 스크롤이 맨 위로 튀는 문제가 생긴다.
                          내부에 훅이 없으므로 직접 호출해도 안전하다. */}
                      {panelOpen && OverlayPanel({ inline: false, open: true })}

                      <EstateEditor
                        open={editorOpen}
                        mode={editorMode}
                        estate={editorEstate}
                        onClose={closeEditor}
                        onSaved={({ ok, estate_no, mode, form, estate }) => {
                          console.log("[App] editor saved:", { ok, estate_no, mode, form, estate });

                          // 1차: 현재 리스트에서 해당 매물만 즉시 갱신 (화면에 바로 반영)
                          setItems((prev) => {
                            if (!prev || !prev.length) return prev;

                            // 백엔드에서 전체 estate 객체를 내려주면 그걸 우선 사용
                            const updated = estate && estate.estate_no
                              ? estate
                              : { estate_no, ...form };

                            return prev.map((p) =>
                              p.estate_no === updated.estate_no ? { ...p, ...updated } : p
                            );
                          });

                          // 2차: 서버 값과 완전히 맞추기 위해 다시 조회
                          load();
                        }}
                        onModeChange={(newMode) => setEditorMode(newMode)}
                        onThumbChange={handleThumbUpdate} // ★ 추가
                      /> 
                    </div>
          )}

          {/* ★ 4. 설정 탭 콘텐츠 추가 */}
          {tab === "settings" && (
            <div className="settings-container" style={{ padding: "20px", flex: 1, overflowY: "auto", minHeight: 0 }}>
              <div className="sms-tab-wrap">
                {/* 사이드 메뉴 — [SMS_TAB_MOBILE_V1] 모바일에서는 상단 가로 배치로 바뀜 */}
                <div className="sms-tab-side">
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    <li
                      className={`sms-tab-item ${settingsSubTab === "sms-receivers" ? "is-active" : ""}`}
                      onClick={() => setSettingsSubTab("sms-receivers")}
                    >
                      📱 SMS 수신처 관리
                    </li>
                    <li
                      className={`sms-tab-item ${settingsSubTab === "sms-send" ? "is-active" : ""}`}
                      onClick={() => setSettingsSubTab("sms-send")}
                    >
                      📤 SMS 전송
                    </li>
                    {/* ★ 백업 메뉴 항목 추가 */}
                    <li
                      className={`sms-tab-item ${settingsSubTab === "backup" ? "is-active" : ""}`}
                      onClick={() => setSettingsSubTab("backup")}
                    >
                      💾 프로젝트 백업
                    </li>
                  </ul>
                </div>

                {/* 설정 세부 내용 영역 */}
                <div className="sms-tab-main">
                  {/* SMS 수신처 관리 */}
                  {settingsSubTab === "sms-receivers" && <ReceiverManagePage />}

                  {/* SMS 전송 */}
                  {settingsSubTab === "sms-send" && <SmsDirectSend />}

                  {/* ★ 백업 패널 */}
                  {settingsSubTab === "backup" && (
                    <div>
                      <h3 style={{ fontSize: "16px", fontWeight: "700", marginBottom: "12px", color: "#1a202c" }}>
                        💾 프로젝트 백업
                      </h3>
                      <BackupButton />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

        </div>
    </>
  );

  return (
    <BrowserRouter>
      {expSoon && (
        <div style={{
          position:"fixed", top:0, left:0, right:0,
          background:"#fff7ed", color:"#9a3412",
          padding:"8px 12px", zIndex:1500, textAlign:"center"
        }}>
          로그인 만료가 임박했습니다. 저장 중인 작업을 마무리하세요.
        </div>
      )}

      {/* ✅ 공통 UI는 Routes 밖 */}
      <Header onLoginClick={() => setLoginOpen(true)} />
      {/* 다가오는 일정(5일 이내) 알림 팝업 — 전역 1회 노출 */}
      <ScheduleAlert />

      <LoginOverlay open={loginOpen} onClose={() => setLoginOpen(false)}>
        <div>
          <div className="login-title">로그인</div>
          <KakaoLoginButton />
          <hr className="login-divider" />
          <EmailLogin onSuccess={() => setLoginOpen(false)} />
          <hr className="login-divider" />
          <EmailRegister onSuccess={() => setLoginOpen(false)} />
        </div>
      </LoginOverlay>

      {/* 접수 알림 팝업 [SUB_ALERT_V1] */}

      <SubmissionAlert />

      {/* [LOGIN_REDIRECT_V1] 로그인 관문 — 미로그인이면 로그인 팝업, guest/basic 이면 직원전용 안내 */}
      <LoginGate onLoginClick={() => setLoginOpen(true)}>
      {/* ✅ Routes는 화면만 */}
      <Routes>
        <Route
          path="/"
          element={  
            <ErrorBoundary>
                <Home content={homeContent} />
            </ErrorBoundary>
          }
        />

// Route 목록 안에 (테스트 후 지우면 됩니다)
<Route path="/tour-test" element={
  <TourPlanner selected={[
    { estate_no: 47323, estate_name: "비손하우징",   roadAddress: "서울 관악구 쑥고개로 118-8", lat: 37.4784716, lng: 126.949523 },
    { estate_no: 47510, estate_name: "제니아빌리지", roadAddress: "서울 관악구 인헌3길 5",     lat: 37.4744474, lng: 126.9672468 },
    { estate_no: 47336, estate_name: "도담파크빌",   roadAddress: "서울 관악구 관악로 113-1",  lat: 37.4751657, lng: 126.9523678 },
  ]} />
} />
        <Route path="/auth/kakao/callback" element={<AuthCallback />} />
        <Route path="/me" element={<MyProfile />} />
        <Route path="/m/:id" element={<MobilePropertyDetail />} />
        <Route path="/settings/sms-receivers" element={<ReceiverManagePage />} />
        {/* [REMOVED_V1] <Route path="/building-search" element={<BuildingSearchPage />} /> */}
        {/* 직원 모바일 물건접수폼 (premium 이상) */}
        <Route path="/staff/intake" element={<StaffIntake />} />
        {/* BLOGPAGE_ROUTE_V1 — 블로그 생성(대표이미지) */}
        <Route path="/blog/create" element={<BlogCreate />} />
        {/* 일반인 매물접수 (로그인 불필요) */}
        <Route path="/register" element={<PublicIntake />} />
        {/* 접수관리 (premium 이상) */}
        <Route path="/submissions" element={<SubmissionPage />} />
        <Route path="/tour-lists" element={<TourListsPage />} />
        {/* [REMOVED_V1] <Route path="/naver-admin" element={<NaverAdmin />} /> */}
        {/* 부동산 실거래 조회 (관리자 전용) - 백엔드 /api/real-trades/* 사용 */}
        <Route path="/real-trades" element={<RealTradePage />} />

        {/* 고정 경로를 먼저 두어야 :id 에 잡아먹히지 않는다 */}
        <Route path="/contracts/list" element={<ContractList />} />
        <Route path="/contracts/calendar" element={<ContractCalendar />} />
        {/* [GONGSIL_MENU_V1] 공실클럽 수집자료 — premium 이상 메뉴에서 진입 */}
        <Route path="/gongsil" element={<GongsilView />} />
        <Route path="/map-popup" element={<MapPopup />} />
        <Route path="/contracts/upload" element={<ContractUpload />} />
        <Route path="/contracts/batch" element={<ContractBatchUpload />} />
        <Route path="/contracts/new" element={<ContractManualEntry />} />
        <Route path="/contracts/:id/edit" element={<ContractEdit />} />
        <Route path="/contracts/:id" element={<ContractDetail />} />

      </Routes>
      </LoginGate>
        {/* [TOUR_SAVE_BAR_V1] 매물 선택 시 하단 고정 바 + 저장 팝업 */}
        {checkedProps.length > 0 && (
          <div style={{position:"fixed",left:0,right:0,bottom:0,zIndex:9998,background:"#fff",borderTop:"1px solid #ddd",padding:"10px 14px",display:"flex",gap:8,alignItems:"center",boxShadow:"0 -2px 8px rgba(0,0,0,0.08)"}}>
            <span style={{fontSize:13,flex:1}}>선택 <b>{checkedProps.length}</b>건</span>
            <button onClick={() => setCheckedProps([])} style={{padding:"7px 12px",fontSize:13,border:"1px solid #ccc",background:"#fff",borderRadius:6,cursor:"pointer"}}>선택해제</button>
            <button onClick={() => setShowTourSave(true)} style={{padding:"7px 16px",fontSize:14,fontWeight:600,border:"1px solid #2a78d6",background:"#2a78d6",color:"#fff",borderRadius:6,cursor:"pointer"}}>안내내역으로 저장</button>
          </div>
        )}
        {showTourSave && (
          <TourSaveModal
            selected={checkedProps}
            onClose={() => setShowTourSave(false)}
            onSaved={(r) => { setShowTourSave(false); setCheckedProps([]); alert(`저장했습니다\n${r.title}`); }}
          />
        )}

      <HoListOverlay
        open={hoListOpen}
        items={hoListItems}
        onSelect={(it) => {
          if (!it?.lat || !it?.lng) return;
          selectEstate(it);
          setMapCenter({
            lat: Number(it.lat),
            lng: Number(it.lng),
            level: 3,
          });
          setHoListOpen(false); // 선택 후 닫기
        }}
        onClose={() => setHoListOpen(false)}
      />

    </BrowserRouter>

    
  );
}